import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

// Textes traduits
const translations = {
  fr: {
    // Navigation & Header
    dashboard: 'Tableau de bord',
    users: 'Utilisateurs',
    packages: 'Colis',
    shipments: 'Départs',
    analytics: 'Analyses',
    settings: 'Paramètres',
    logout: 'Déconnexion',
    login: 'Se Connecter',
    createCompany: 'Créer Mon Entreprise',
    trackPackage: 'Suivre un Colis',
    
    // Landing Page - Hero Section
    landingHeroBadge: '🌍 Révolutionnez Votre Transport International',
    landingHeroTitle: 'FretManager',
    landingHeroSubtitle: 'Transformez votre entreprise de transport avec une solution qui simplifie vos opérations, fidélise vos clients et booste votre croissance',
    landingHeroSubtitleBold1: 'Transformez votre entreprise de transport',
    landingHeroSubtitleBold2: 'simplifie vos opérations',
    landingHeroSubtitleBold3: 'fidélise vos clients',
    landingHeroSubtitleBold4: 'booste votre croissance',
    landingChallengesTitle: '🎯 FretManager résout vos défis quotidiens',
    landingChallenge1: 'Erreurs de saisie coûteuses',
    landingChallenge2: 'Clients qui attendent des nouvelles',
    landingChallenge3: 'Gestion manuelle chronophage',
    landingSolution1: 'Clients autonomes avec QR codes',
    landingSolution2: 'Notifications automatiques 24/7',
    landingSolution3: 'Tableau de bord intelligent',
    landingCtaFree: 'Essai Gratuit - 0€',
    landingCtaTrack: 'Suivre un Colis',
    
    // Landing Page - Stats
    landingStatsTitle: '🏆 Impact business immédiat pour votre entreprise',
    landingStat1Value: '-75%',
    landingStat1Label: 'Erreurs de saisie',
    landingStat2Value: '+60%',
    landingStat2Label: 'Satisfaction client',
    landingStat3Value: '-50%',
    landingStat3Label: 'Temps de traitement',
    landingStat4Value: '24/7',
    landingStat4Label: 'Suivi automatique',
    
    // Landing Page - Business Benefits
    landingBenefitsTitle: 'Pourquoi les entreprises choisissent FretManager ?',
    landingBenefitsSubtitle: 'Au-delà de la technologie, nous vous aidons à construire une entreprise de transport plus humaine et profitable',
    landingProblemsTitle: '🔴 Vos défis actuels nous parlent',
    landingProblem1Title: '😰 "Mes clients m\'appellent sans arrêt"',
    landingProblem1Desc: 'Ils veulent savoir où sont leurs colis, quand ils arriveront... Votre téléphone n\'arrête pas de sonner.',
    landingProblem2Title: '😤 "Les erreurs me coûtent cher"',
    landingProblem2Desc: 'Mauvaises adresses, colis perdus, clients mécontents... Les erreurs de saisie vous font perdre temps et argent.',
    landingProblem3Title: '😵 "Je croule sous la paperasse"',
    landingProblem3Desc: 'Fichiers Excel, carnets, post-it... Votre bureau ressemble à un champ de bataille administratif.',
    landingSolutionsTitle: '✅ Avec FretManager, respirez enfin',
    landingSolution1Title: '😌 "Mes clients sont informés automatiquement"',
    landingSolution1Desc: 'Emails professionnels envoyés à chaque étape. Vos clients savent toujours où en est leur colis.',
    landingSolution2Title: '😊 "Zéro erreur de saisie"',
    landingSolution2Desc: 'Vos clients scannent un QR code et saisissent eux-mêmes leurs informations. Plus d\'erreurs !',
    landingSolution3Title: '🎯 "Tout est centralisé et simple"',
    landingSolution3Desc: 'Un tableau de bord clair, des départs organisés, des statistiques parlantes. Enfin du temps pour votre business !',
    
    // Landing Page - ROI Calculator
    landingRoiTitle: '💰 Calculez votre retour sur investissement',
    landingRoi1Value: '2h/jour',
    landingRoi1Label: 'économisées sur la paperasse',
    landingRoi2Value: '×3',
    landingRoi2Label: 'clients satisfaits en plus',
    landingRoi3Value: '-80%',
    landingRoi3Label: 'd\'appels de réclamation',
    landingRoiProfit: 'Pour une entreprise de 50 colis/semaine : +15,000€/an de bénéfices',
    
    // Landing Page - Features
    landingFeaturesTitle: 'Fonctionnalités Avancées',
    landingFeaturesSubtitle: 'FretManager intègre les technologies les plus récentes pour une expérience utilisateur optimale',
    landingFeature1Title: 'Espace entreprise dédié',
    landingFeature1Desc: 'Pilotez toute votre activité depuis un seul endroit : équipes, partenaires et départs, dans un espace privé et sécurisé.',
    landingFeature1Benefit1: 'Espace privé et sécurisé',
    landingFeature1Benefit2: 'Rôles et permissions par équipe',
    landingFeature1Benefit3: 'Prêt à grandir avec vous',
    landingFeature2Title: 'QR Code Client Autonome',
    landingFeature2Desc: 'Les clients scannent un QR code et saisissent leurs informations directement. Plus d\'erreurs de saisie partenaire !',
    landingFeature2Benefit1: 'Saisie client directe',
    landingFeature2Benefit2: 'Réduction des erreurs',
    landingFeature2Benefit3: 'Gain de temps partenaire',
    landingFeature3Title: 'Notifications Email Automatiques',
    landingFeature3Desc: 'Emails professionnels automatiques avec SendGrid : confirmation d\'expédition, suivi de statut, alertes livraison.',
    landingFeature3Benefit1: 'Templates professionnels',
    landingFeature3Benefit2: 'Estimation d\'arrivée',
    landingFeature3Benefit3: 'Tracking automatique',
    landingFeature4Title: 'Support Multilingue',
    landingFeature4Desc: 'Interface disponible en français et anglais. Changement de langue instantané pour utilisateurs internationaux.',
    landingFeature4Benefit1: 'Français / English',
    landingFeature4Benefit2: 'Changement instantané',
    landingFeature4Benefit3: 'Interface adaptée',
    landingFeature5Title: 'Gestion des Paiements',
    landingFeature5Desc: 'Suivi simple du statut de paiement (Réglé/Non réglé) avec indicateurs visuels dans toutes les interfaces.',
    landingFeature5Benefit1: 'Statut visuel clair',
    landingFeature5Benefit2: 'Suivi comptable',
    landingFeature5Benefit3: 'Alertes impayés',
    landingFeature6Title: 'Temps Réel & WebSockets',
    landingFeature6Desc: 'Notifications en temps réel, utilisateurs connectés, mise à jour instantanée des statuts de colis.',
    landingFeature6Benefit1: 'Notifications instant',
    landingFeature6Benefit2: 'Utilisateurs en ligne',
    landingFeature6Benefit3: 'Synchronisation live',
    landingFeaturePremium: 'Fonctionnalité Premium',
    
    // Landing Page - User Roles
    landingRolesTitle: 'Rôles Utilisateurs',
    landingRolesSubtitle: 'Une interface adaptée pour chaque type d\'utilisateur',
    landingRoleSuperAdmin: 'Super Admin',
    landingRoleSuperAdminDesc: 'Gestion complète de l\'entreprise, utilisateurs, départs',
    landingRoleSuperAdminFeature1: 'Création d\'entreprise',
    landingRoleSuperAdminFeature2: 'Gestion utilisateurs',
    landingRoleSuperAdminFeature3: 'Analytics complètes',
    landingRoleCountryAdmin: 'Admin Pays',
    landingRoleCountryAdminDesc: 'Administration par pays, gestion des partenaires locaux',
    landingRoleCountryAdminFeature1: 'Gestion partenaires pays',
    landingRoleCountryAdminFeature2: 'Départs régionaux',
    landingRoleCountryAdminFeature3: 'Statistiques pays',
    landingRolePartnerCollection: 'Partenaire Collection',
    landingRolePartnerCollectionDesc: 'Collecte de colis, génération QR code, gestion départs',
    landingRolePartnerCollectionFeature1: 'QR Code client',
    landingRolePartnerCollectionFeature2: 'Gestion colis',
    landingRolePartnerCollectionFeature3: 'Vue départs',
    landingRolePartnerDelivery: 'Partenaire Livraison',
    landingRolePartnerDeliveryDesc: 'Livraison locale, validation OCE, confirmation GPS',
    landingRolePartnerDeliveryFeature1: 'Validation livraison',
    landingRolePartnerDeliveryFeature2: 'Scan OCE',
    landingRolePartnerDeliveryFeature3: 'Géolocalisation',
    landingRoleClient: 'Client',
    landingRoleClientDesc: 'Suivi de colis, historique d\'expéditions',
    landingRoleClientFeature1: 'Tracking colis',
    landingRoleClientFeature2: 'Historique',
    landingRoleClientFeature3: 'Notifications',
    
    // Landing Page - Testimonials
    landingTestimonialsTitle: 'Ils ont transformé leur business avec FretManager',
    landingTestimonialsSubtitle: 'Des entrepreneurs comme vous partagent leur expérience',
    landingTestimonial1Author: 'Marie Diallo',
    landingTestimonial1Company: 'Express Sahel Transport',
    landingTestimonial1Text: '"Mes clients adorent pouvoir scanner le QR code et saisir eux-mêmes leurs informations. Plus d\'erreurs, plus de rappels ! Mon chiffre d\'affaires a augmenté de 40% en 6 mois."',
    landingTestimonial1Impact: '+40% CA • -90% erreurs de saisie',
    landingTestimonial2Author: 'Amadou Kouassi',
    landingTestimonial2Company: 'Logistics Côte d\'Or',
    landingTestimonial2Text: '"Avant, je passais 3h par jour à faire du suivi clients. Maintenant, les emails se font automatiquement. Je peux enfin me concentrer sur développer mon entreprise !"',
    landingTestimonial2Impact: '-75% temps administratif • +25 nouveaux clients',
    landingTestimonial3Author: 'Fatima Ben Ali',
    landingTestimonial3Company: 'Maghreb Fret Express',
    landingTestimonial3Text: '"L\'interface multilingue est parfaite pour mes clients français et arabes. La gestion des départs est si simple que même mon fils de 16 ans peut m\'aider !"',
    landingTestimonial3Impact: '2 langues • Formation famille en 2h',
    landingTestimonialsRating: '🏆 Note moyenne : 4.9/5 (127 avis)',
    landingTestimonialsTagline: '"La solution la plus complète et facile à utiliser du marché"',
    landingTestimonialsBenefits: 'Installation en 24h • Support français • Formation incluse',
    
    // Landing Page - Technology
    landingTechTitle: 'Technologies Modernes',
    landingTechPerformanceTitle: 'Performance',
    landingTechPerformanceDesc: 'FastAPI + React + MongoDB pour une performance optimale',
    landingTechSecurityTitle: 'Sécurité',
    landingTechSecurityDesc: 'JWT, isolation multi-tenant, audit trail complet',
    landingTechRealtimeTitle: 'Temps Réel',
    landingTechRealtimeDesc: 'WebSockets pour notifications et mises à jour instantanées',
    
    // Landing Page - CTA Final
    landingCtaTitle: 'Commencez Votre Transformation Dès Aujourd\'hui',
    landingCtaSubtitle: 'Rejoignez les entrepreneurs visionnaires qui ont choisi de moderniser leur transport',
    landingCtaBenefit1Title: 'Démarrage Rapide',
    landingCtaBenefit1Desc: 'Opérationnel en moins de 24h',
    landingCtaBenefit2Title: 'Formation Incluse',
    landingCtaBenefit2Desc: 'Accompagnement personnalisé',
    landingCtaBenefit3Title: 'Résultats Garantis',
    landingCtaBenefit3Desc: 'ROI visible dès le 1er mois',
    landingCtaButton1: 'Démarrer Gratuitement - 0€',
    landingCtaButton2: 'J\'ai Déjà un Compte',
    landingCtaGuarantees: 'Aucun engagement • Configuration gratuite • Support 7j/7',
    
    // Landing Page - Footer
    landingFooterDesc: 'Plateforme de gestion de transport international - Version 1.0.0',
    landingFooterCopyright: '© 2024 FretManager • Transport International • Multi-tenant Platform',
    
    // Colis & Package Management
    createPackage: 'Créer un colis',
    packageCode: 'Code colis',
    sender: 'Expéditeur',
    recipient: 'Destinataire',
    recipientName: 'Nom du destinataire',
    recipientPhone: 'Téléphone destinataire',
    weight: 'Poids',
    description: 'Description',
    originCountry: 'Pays d\'origine',
    destinationCountry: 'Pays de destination',
    status: 'Statut',
    paymentStatus: 'Statut paiement',
    isPaid: 'Payé',
    senderEmail: 'Email expéditeur',
    
    // Shipments & Flight Management
    createShipment: 'Créer un départ',
    flightName: 'Nom du vol',
    flightNumber: 'Numéro de vol',
    expectedArrivalDate: 'Date d\'arrivée prévue',
    actualArrivalDate: 'Date d\'arrivée réelle',
    departureDate: 'Date de départ',
    shipmentMonitoring: 'Surveillance départs',
    delayedShipments: 'Départs en retard',
    arrivingSoon: 'Arrivées prochaines',
    inTransitShipments: 'En transit',
    cronJobStatus: 'Statut des tâches automatiques',
    runManualCheck: 'Vérification manuelle',
    lastStatusCheck: 'Dernière vérification',
    delayNotifications: 'Notifications de retard',
    automaticTracking: 'Suivi automatique',
    
    // Flight API Integration
    flightApiStatus: 'API de vols',
    flightApiEnabled: 'API activée',
    flightApiDisabled: 'API désactivée',
    checkFlightStatus: 'Vérifier le statut du vol',
    flightNotFound: 'Vol non trouvé',
    flightStatusUpdated: 'Statut de vol mis à jour',
    realTimeTracking: 'Suivi temps réel',
    flightDetails: 'Détails du vol',
    searchFlights: 'Rechercher des vols',
    departureAirport: 'Aéroport de départ',
    arrivalAirport: 'Aéroport d\'arrivée',
    aircraftType: 'Type d\'avion',
    gate: 'Porte',
    terminal: 'Terminal',
    delayMinutes: 'Retard (minutes)',
    
    // Company Settings
    companySettings: 'Paramètres Entreprise',
    generalSettings: 'Paramètres Généraux',
    transportSettings: 'Paramètres Transport',
    communicationSettings: 'Communication & Notifications',
    userAccessSettings: 'Utilisateurs & Accès',
    financialSettings: 'Paramètres Financiers',
    enabledFeatures: 'Fonctionnalités Activées',
    featureLockedByPlan: 'Certaines fonctionnalités nécessitent un plan supérieur',
    whatsapp_ai_responses: 'Réponses IA WhatsApp',
    broadcast: 'Diffusion',

    // General Settings
    companyName: 'Nom de l\'entreprise',
    companyType: 'Type d\'entreprise',
    logoUrl: 'URL du logo',
    primaryColor: 'Couleur principale',
    secondaryColor: 'Couleur secondaire',
    primaryCurrency: 'Devise principale',
    timezone: 'Fuseau horaire',
    originCountry: 'Pays d\'origine',
    servedCountries: 'Pays desservis',
    warehouseAddresses: 'Adresses entrepôts',
    defaultLanguage: 'Langue par défaut',
    
    // Company Types
    international_freight: 'Fret International',
    local_partner: 'Partenaire Local',
    transit_logistics: 'Logistique de Transit',
    warehouse_operator: 'Opérateur d\'Entrepôt',
    customs_broker: 'Courtier en Douane',
    
    // Transport Settings
    mainAirline: 'Compagnie aérienne principale',
    freightTypes: 'Types de fret',
    defaultFreightType: 'Type de fret par défaut',
    averageBagWeight: 'Poids moyen par sac (kg)',
    collectionMode: 'Mode de collecte',
    travelFrequency: 'Fréquence de voyage',
    defaultArrivalAirports: 'Aéroports d\'arrivée par défaut',
    averageCustomsTimeHours: 'Temps moyen de dédouanement (heures)',
    flightApiEnabled: 'API de vols activée',
    trackingMode: 'Mode de suivi',
    trackingModeManual: 'Manuel',
    trackingModeAutomatic: 'Automatique',
    trackingModeDescription: 'Comment les statuts de vos départs sont mis à jour',
    trackingModeManualDesc: 'Changez manuellement le statut de chaque départ',
    trackingModeAutoDesc: 'Statuts mis à jour via l\'API de suivi des vols',
    trackingModeProRequired: 'Disponible avec le plan Pro ou Enterprise',
    trackingModeBadgeManual: 'Suivi manuel',
    trackingModeBadgeAuto: 'Suivi auto',
    statusChangeInline: 'Changer le statut',

    // Freight Types
    express: 'Express',
    standard: 'Standard',
    economic: 'Économique',
    fragile: 'Fragile',
    
    // Collection Modes
    depot_only: 'Dépôt uniquement',
    home_collection: 'Collecte à domicile',
    both: 'Les deux',
    
    // Travel Frequency
    weekly: 'Hebdomadaire',
    biweekly: 'Bi-hebdomadaire',
    monthly: 'Mensuel',
    on_demand: 'À la demande',
    
    // Communication Settings
    senderEmail: 'Email d\'envoi',
    senderName: 'Nom d\'expéditeur',
    whatsappNumber: 'Numéro WhatsApp',
    smsApiEnabled: 'API SMS activée',
    aiServiceEnabled: 'Service IA activé',
    cronFrequencyHours: 'Fréquence de vérification (heures)',
    automationLevel: 'Niveau d\'automatisation',
    autoNotificationRules: 'Règles de notification automatique',
    
    // Automation Levels
    basic: 'Basique',
    medium: 'Moyen',
    advanced: 'Avancé',
    
    // Financial Settings
    acceptedPaymentMethods: 'Méthodes de paiement acceptées',
    billingCurrencies: 'Devises de facturation',
    pricingModel: 'Modèle de tarification',
    autoTaxReporting: 'Déclaration fiscale automatique',
    exchangeRateApiEnabled: 'API de taux de change activée',
    defaultMarginPercent: 'Marge par défaut (%)',
    
    // Payment Methods
    cash: 'Espèces',
    card: 'Carte',
    bank_transfer: 'Virement bancaire',
    mobile_money: 'Mobile Money',
    
    // Features
    qrCodeClient: 'QR Code Client',
    multiFreightTypes: 'Types de fret multiples',
    multiCountry: 'Multi-pays',
    customBranding: 'Image de marque personnalisée',
    multiWarehouse: 'Entrepôts multiples',
    advancedAnalytics: 'Analytics avancées',
    realtimeTracking: 'Suivi temps réel',
    
    // Statuts
    registered: 'Enregistré',
    pending_collection: 'En attente',
    collected: 'Collecté',
    verified: 'Vérifié',
    in_transit: 'En transit',
    arrived: 'Arrivé',
    customs_cleared: 'Dédouané',
    ready_for_pickup: 'Prêt',
    delivered: 'Livré',
    
    // Shipment Statuses
    planned: 'Planifié',
    scheduled: 'Programmé',
    delayed: 'Retardé',
    completed: 'Terminé',
    cancelled: 'Annulé',
    
    // Paiement
    paid: 'Réglé',
    unpaid: 'Non réglé',
    
    // Actions
    create: 'Créer',
    edit: 'Modifier',
    delete: 'Supprimer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    validate: 'Valider',
    submit: 'Soumettre',
    search: 'Rechercher',
    filter: 'Filtrer',
    
    // QR Code
    createQRCode: 'Créer QR Code Client',
    qrCodeFor: 'QR Code pour',
    scanQR: 'Scannez ce QR code',
    qrCodeSession: 'Session QR Code',
    qrExpires: 'Expire le',
    qrClientForm: 'Formulaire Client QR',
    
    // Formulaires
    name: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    country: 'Pays',
    city: 'Ville',
    address: 'Adresse',
    required: 'Requis',
    optional: 'Optionnel',
    
    // Messages & Notifications
    success: 'Succès',
    error: 'Erreur',
    warning: 'Avertissement',
    info: 'Information',
    loading: 'Chargement...',
    noData: 'Aucune donnée',
    filtered: 'filtré',
    searchPlaceholderGeneric: 'Rechercher...',
    noResults: 'Aucun résultat',
    edit: 'Modifier',
    save: 'Enregistrer',
    delete: 'Supprimer',
    back: 'Retour',
    close: 'Fermer',
    globalSearch: 'Recherche globale',
    errorLoading: 'Erreur lors du chargement',
    errorCreating: 'Erreur lors de la création',
    errorUpdating: 'Erreur lors de la modification',
    errorStatusChange: 'Erreur lors du changement de statut',
    errorCustomsClearance: 'Erreur lors du dédouanement',
    errorAssigning: 'Erreur lors de l\'assignation',
    noShipmentsAvailable: 'Aucun départ disponible',
    noPendingPackages: 'Aucun colis en attente',
    noPackagesAvailable: 'Aucun colis disponible pour créer un départ',
    noRegisteredPackages: 'Aucun colis enregistré',
    editShipment: 'Modifier le Départ',
    sessionExpired: 'Session expirée - Veuillez vous reconnecter',
    insufficientPermissions: 'Permissions insuffisantes',
    statusChanged: 'Statut modifié',
    currentStatus: 'Statut actuel',
    searchByShipmentPlaceholder: 'Rechercher par départ, pays, statut, partenaire, code OCE...',
    searchByOcePlaceholder: 'Rechercher par code OCE, nom expéditeur, destinataire...',
    filterByPartner: 'Filtrer par partenaire',
    selectStatus: 'Sélectionner un statut',
    statusChangeReason: 'Expliquez la raison de ce changement de statut...',
    customsDetailsPlaceholder: 'Détails du dédouanement...',
    groupCustomsPlaceholder: 'Détails du dédouanement groupé...',
    packageSearchTitle: 'Recherche de Colis',
    packageSearchDesc: 'Recherchez un colis et découvrez dans quel départ il se trouve',
    noPackagesFoundFor: 'Aucun colis trouvé pour',
    noShipmentsInProgress: 'Aucun départ en cours',
    noCompletedShipments: 'Aucun départ achevé',
    shipmentsInProgress: 'Départs En Cours',
    completedShipments: 'Départs Achevés',
    allPartners: 'Tous les partenaires',
    changeShipmentStatus: 'Changer le statut de la carréaison',
    changePackageStatus: 'Changer le statut du colis',
    newStatus: 'Nouveau statut',
    changeReason: 'Raison du changement',
    modifying: 'Modification...',
    confirm: 'Confirmer',
    inProgress: 'En cours...',
    customsClearPackage: 'Dédouaner le colis',
    confirmCustomsClearance: 'Confirmer le dédouanement du colis',
    noteOptional: 'Note (optionnelle)',
    confirmCustoms: 'Confirmer le dédouanement',
    bulkCustomsClearance: 'Dédouanement groupé',
    clearNPackages: 'Dédouaner {n} colis',
    clearNPackagesOf: 'Dédouaner {n} colis de la carréaison',
    minCharsSearch: 'Tapez au moins 3 caractères pour rechercher...',
    // Broadcast
    broadcast: 'Diffuser',
    broadcastSendNotif: 'Envoyer une notification aux expéditeurs et destinataires de ce départ',
    broadcastSent: 'Diffusion envoyée',
    recipientsTargeted: 'destinataire(s) ciblé(s)',
    showRecipients: 'Voir les destinataires',
    hideRecipients: 'Masquer les destinataires',
    loadingRecipients: 'Chargement des destinataires...',
    sendingInProgress: 'Envoi en cours...',
    sent: 'Envoyé',
    failed: 'Échoué',
    noRecipientsFound: 'Aucun destinataire trouvé',
    subjectLabel: 'Objet',
    subjectPlaceholder: 'Objet de la notification',
    messageLabel: 'Message',
    messagePlaceholder: 'Votre message...',
    broadcastChannels: 'Canaux de diffusion',
    subjectAndMessageRequired: 'Objet et message requis',
    selectAtLeastOneChannel: 'Sélectionnez au moins un canal',
    errorSending: 'Erreur lors de l\'envoi',
    recipients: 'destinataire(s)',
    confirmDelete: 'Confirmer la suppression',
    deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
    
    // Auth & Login
    loginTitle: 'Gestion de Fret Aérien',
    loginSubtitle: 'Connectez-vous à votre compte',
    loginButton: 'Se connecter',
    loginLoading: 'Connexion...',
    register: 'S\'inscrire',
    forgotPassword: 'Mot de passe oublié',
    rememberMe: 'Se souvenir de moi',
    noAccount: 'Pas de compte ?',
    emailPlaceholder: 'vous@exemple.com',
    passwordPlaceholder: '••••••••',
    trackPackageLink: 'Suivre un colis (Code OCE)',
    newCompany: 'Nouvelle entreprise ?',
    createMyCompanyLink: 'Créer mon entreprise',
    
    // Company & Organization
    company: 'Entreprise',
    companyName: 'Nom de l\'entreprise',
    createCompanyTitle: 'Créer une entreprise',
    partner: 'Partenaire',
    admin: 'Administrateur',
    superAdmin: 'Super Administrateur',
    countryAdmin: 'Administrateur Pays',
    localPartner: 'Partenaire Local',
    client: 'Client',
    
    // Dashboard & Navigation
    welcomeTo: 'Bienvenue dans',
    overview: 'Aperçu',
    statistics: 'Statistiques',
    recentActivity: 'Activité récente',
    quickActions: 'Actions rapides',
    adminShipmentsView: 'Vue Départs',
    myShipments: 'Mes Départs',
    myPackages: 'Mes Colis',
    deliveries: 'Livraisons',
    
    // Common UI Elements
    close: 'Fermer',
    open: 'Ouvrir',
    expand: 'Développer',
    collapse: 'Réduire',
    refresh: 'Actualiser',
    export: 'Exporter',
    import: 'Importer',
    print: 'Imprimer',
    download: 'Télécharger',
    upload: 'Téléverser',
    
    // Time & Dates
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    thisWeek: 'Cette semaine',
    thisMonth: 'Ce mois',
    thisYear: 'Cette année',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    
    // General Terms
    total: 'Total',
    count: 'Nombre',
    active: 'Actif',
    inactive: 'Inactif',
    enabled: 'Activé',
    disabled: 'Désactivé',
    available: 'Disponible',
    unavailable: 'Indisponible',

    // Audit & Security
    auditLog: "Journal d'audit",
    auditLogs: "Journal d'audit",
    security: 'Sécurité',
    changePassword: 'Changer le mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',

    // Users Management
    createUser: 'Créer un utilisateur',
    editUser: "Modifier l'utilisateur",
    deleteUser: "Supprimer l'utilisateur",

    // Empty States & Misc
    noPackages: 'Aucun colis',
    noShipments: 'Aucun départ',
    noUsers: 'Aucun utilisateur',
    pageNotFound: 'Page introuvable',
    awaiting_customs: 'En attente de dédouanement',

    // Pricing Section
    pricingTitle: 'Tarifs Simples et Transparents',
    pricingSubtitle: 'Choisissez le plan adapté à la taille de votre entreprise. Changez de plan à tout moment.',
    pricingMonthly: 'Mensuel',
    pricingYearly: 'Annuel',
    pricingYearlySave: 'Économisez 20%',
    pricingFrom: 'À partir de',
    pricingPerMonth: '/mois',
    pricingPerYear: '/an',
    pricingPopular: 'Populaire',
    pricingCta: 'Choisir ce plan',
    pricingCtaEnterprise: 'Nous contacter',
    pricingCtaTrial: 'Démarrer l\'essai gratuit',

    // Pricing - Starter
    pricingStarterName: 'Starter',
    pricingStarterDesc: 'Idéal pour démarrer votre activité de fret',
    pricingStarterFeature1: 'Jusqu\'à 100 colis/mois',
    pricingStarterFeature2: '5 départs/mois',
    pricingStarterFeature3: '3 partenaires',
    pricingStarterFeature4: '5 utilisateurs',
    pricingStarterFeature5: 'Notifications email',
    pricingStarterFeature6: 'QR Code client',
    pricingStarterFeature7: 'Analytics de base',

    // Pricing - Pro
    pricingProName: 'Pro',
    pricingProDesc: 'Pour les entreprises en croissance',
    pricingProFeature1: 'Jusqu\'à 500 colis/mois',
    pricingProFeature2: '20 départs/mois',
    pricingProFeature3: '10 partenaires',
    pricingProFeature4: '20 utilisateurs',
    pricingProFeature5: 'Tout Starter +',
    pricingProFeature6: 'Notifications WhatsApp',
    pricingProFeature7: 'Broadcast & Notifications en temps réel',
    pricingProFeature8: 'Analytics avancées',
    pricingProFeature9: 'Module Finance',

    // Pricing - Enterprise
    pricingEnterpriseName: 'Enterprise',
    pricingEnterpriseDesc: 'Pour les grandes opérations logistiques',
    pricingEnterpriseFeature1: 'Colis illimités',
    pricingEnterpriseFeature2: 'Départs illimités',
    pricingEnterpriseFeature3: 'Partenaires illimités',
    pricingEnterpriseFeature4: 'Utilisateurs illimités',
    pricingEnterpriseFeature5: 'Tout Pro +',
    pricingEnterpriseFeature6: 'Support prioritaire dédié',
    pricingEnterpriseFeature7: 'Intégrations sur mesure',
    pricingEnterpriseFeature8: 'SLA garanti',
    pricingEnterpriseFeature9: 'Account manager dédié',

    // Business Stats (landing page)
    statCompanies: 'Entreprises actives',
    statPackages: 'Colis suivis',
    statCountries: 'Pays couverts',
    statUptime: 'Disponibilité',

    // Improved CTA
    ctaStartTrial: 'Démarrer l\'essai gratuit',
    ctaTrialSubtext: '14 jours gratuits, sans carte bancaire',

    // Nav anchors
    navFeatures: 'Fonctionnalités',
    navPricing: 'Tarifs',
    navTestimonials: 'Témoignages',
    navSectionLabel: 'Gestion de fret',
    navBenefits: 'Avantages',
    navSolutions: 'Plateforme',
    navDemo: 'Démonstration',
    navTrust: 'Exploitation',
    navRequestDemo: 'Demander une démo',
    breadcrumbHome: 'Accueil',
    breadcrumbLabel: 'Fil d’Ariane',

    // Footer enriched
    footerProduct: 'Produit',
    footerCompany: 'Entreprise',
    footerSupport: 'Support',
    footerLegal: 'Légal',
    footerAbout: 'À propos',
    footerBlog: 'Blog',
    footerCareers: 'Carrières',
    footerContact: 'Contact',
    footerHelpCenter: 'Centre d\'aide',
    footerDocumentation: 'Documentation',
    footerApiReference: 'Référence API',
    footerStatusPage: 'Page de statut',
    footerPrivacy: 'Confidentialité',
    footerTerms: 'Conditions d\'utilisation',
    footerCookies: 'Cookies',

    // Plan & Billing
    subscription: 'Abonnement',
    planAndBilling: 'Plan & Facturation',
    planAndBillingSubtitle: 'Gérez votre abonnement, suivez votre consommation et vos limites',
    subscriptionManagement: 'Gestion Abonnement',
    currentPlan: 'Plan actuel',
    changePlan: 'Changer de plan',
    upgradePlan: 'Mettre à niveau',
    manageBilling: 'Gérer la facturation',
    renewalDate: 'Date de renouvellement',
    renewsOn: 'Renouvellement le',
    usage: 'Utilisation',
    usageThisMonth: 'Utilisation ce mois',
    allSubscriptions: 'Tous les abonnements',
    overridePlan: 'Modifier le plan',
    monthlyRevenue: 'Revenu mensuel récurrent',
    planMenu: 'Plan & Facturation',
    usersCount: 'Utilisateurs',
    packagesMonth: 'Colis ce mois',
    shipmentsMonth: 'Départs ce mois',
    broadcastsSent: 'Messages diffusés',
    partnersCount: 'Partenaires',
    totalPackages: 'Colis total',
    unlimited: 'Illimité',
    ofLimit: 'sur',
    planFeatures: 'Fonctionnalités incluses',
    planLimits: 'Limites du plan',
    perMonth: '/mois',
    perYear: '/an',
    activeUsers: 'utilisateurs actifs',
    thisMonth: 'ce mois',
    totalSent: 'envoyés au total',
    noSubscription: 'Aucun abonnement actif',
    noSubscriptionDesc: 'Choisissez un plan pour débloquer toutes les fonctionnalités',
    comparePlans: 'Comparer les plans',
    featureEmail: 'Notifications email',
    featureQr: 'QR Code',
    featureBasicAnalytics: 'Analytiques basiques',
    featureAdvancedAnalytics: 'Analytiques avancées',
    featureWhatsapp: 'Notifications WhatsApp',
    featureBroadcast: 'Diffusion de messages',
    featureFinance: 'Module finance',
    featureWhatsappAi: 'Réponses IA WhatsApp',

    // Shared Auth
    passwordsMismatch: 'Les mots de passe ne correspondent pas',
    passwordMinLength: 'Le mot de passe doit contenir au moins 6 caractères',
    home: 'Accueil',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    signIn: 'Se connecter',
    or: 'ou',
    back: 'Retour',
    creating: 'Création...',
    continue: 'Continuer',

    // Parcours de création de colis (package-form)
    packageStep_route: 'Trajet',
    packageStep_contacts: 'Contacts',
    packageStep_items: 'Colis',
    packageStep_payment: 'Paiement',

    // Login page extras
    passwordResetSuccess: 'Mot de passe réinitialisé avec succès ! Vous pouvez maintenant vous connecter.',
    loginHeroTitle: 'Simplifiez la gestion de votre fret',
    loginAIDesc: 'Suivez vos envois, gérez vos partenaires et optimisez vos opérations logistiques depuis une seule plateforme.',
    loginFeatureTracking: 'Suivi en temps réel',
    loginFeatureMultiCountry: 'Gestion multi-pays',
    loginFeatureNotifications: 'Notifications automatiques',

    // Register page
    registrationSuccess: 'Votre compte a été soumis pour approbation',
    redirectingToLogin: 'Redirection vers la page de connexion...',
    createAccount: 'Créer un compte',
    registerSubtitle: 'Inscrivez-vous pour suivre vos colis',
    fullName: 'Nom complet',
    yourName: 'Votre nom',
    registering: 'Inscription...',
    signUp: "S'inscrire",

    // Forgot password page
    forgotPasswordTitle: 'Mot de passe oublié ?',
    forgotPasswordDesc: 'Entrez votre email pour recevoir un lien de réinitialisation',
    resetMyPassword: 'Réinitialiser mon mot de passe',
    resetEmailDesc: 'Un email avec un lien de réinitialisation sera envoyé à cette adresse',
    emailAddress: 'Adresse email',
    emailPlaceholderForgot: 'votre.email@exemple.com',
    sendingEmail: 'Envoi en cours...',
    sendResetLink: 'Envoyer le lien de réinitialisation',
    backToLogin: 'Retour à la connexion',
    checkSpamTip: 'Vérifiez aussi vos spams si vous ne recevez pas l\'email.',

    // Reset password page
    resetTokenMissing: 'Token de réinitialisation manquant ou invalide',
    invalidResetLink: 'Lien de réinitialisation invalide ou expiré.',
    requestNewLink: 'Demander un nouveau lien',
    newPasswordTitle: 'Nouveau mot de passe',
    newPasswordDesc: 'Définissez votre nouveau mot de passe sécurisé',
    resetPasswordCardTitle: 'Réinitialiser le mot de passe',
    chooseStrongPassword: 'Choisissez un mot de passe fort avec au moins 6 caractères',
    enterNewPassword: 'Entrez votre nouveau mot de passe',
    confirmYourPassword: 'Confirmez votre nouveau mot de passe',
    passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
    passwordsDontMatch: 'Les mots de passe ne correspondent pas',
    resetting: 'Réinitialisation...',
    setNewPassword: 'Définir le nouveau mot de passe',

    // CreateCompany page
    createYourCompany: 'Créer votre Entreprise',
    stepXofY: 'Étape {step} sur {total}',
    companyInfoStep: 'Informations de l\'entreprise',
    superAdminStep: 'Création du super administrateur',
    companyCreatedSuccess: 'Entreprise créée avec succès !',
    createCompanyError: 'Erreur lors de la création de l\'entreprise',
    superAdminCreatedSuccess: 'Super administrateur créé avec succès ! Vous pouvez maintenant vous connecter.',
    createSuperAdminError: 'Erreur lors de la création du super administrateur',
    companyInfoTitle: 'Informations de l\'Entreprise',
    companyInfoDesc: 'Renseignez les informations de votre entreprise de transport',
    companyNameRequired: 'Nom de l\'entreprise *',
    companyCodeRequired: 'Code entreprise *',
    countryRequired: 'Pays *',
    selectCountry: 'Sélectionnez un pays',
    contactEmailRequired: 'Email de contact *',
    phoneOptional: 'Téléphone',
    descriptionOptional: 'Description',
    descriptionPlaceholder: 'Description de votre entreprise de transport...',
    createCompanyButton: 'Créer l\'entreprise',
    superAdminTitle: 'Création du Super Administrateur',
    superAdminDesc: 'Créez le compte administrateur principal de votre entreprise',
    fullNameRequired: 'Nom complet *',
    emailRequired: 'Email *',
    passwordRequired: 'Mot de passe *',
    passwordMin6: 'Minimum 6 caractères',
    confirmPasswordRequired: 'Confirmer le mot de passe *',
    confirmPasswordPlaceholder: 'Confirmez le mot de passe',

    // RegisterCompany page
    joinFretManager: 'Rejoignez FretManager',
    createYourSpace: 'Créez votre espace en 3 étapes et commencez à gérer vos expéditions',
    freeRegistration: 'Inscription gratuite',
    multiCountryFromStart: 'Multi-pays dès le départ',
    operationalIn5Min: 'Opérationnel en 5 minutes',
    createYourCompanyTitle: 'Créer votre entreprise',
    stepXofTotal: 'Étape {step} sur 3',
    accountInfo: 'Informations du compte',
    companyInfo: 'Informations de l\'entreprise',
    freightType: 'Type de fret *',
    airFreight: 'Fret Aérien',
    maritimeFreight: 'Fret Maritime',
    airAndMaritimeFreight: 'Fret Aérien + Maritime',
    shippingCountry: 'Pays d\'expédition (Siège) *',
    selectACountry: 'Sélectionner un pays',
    defaultDeliveryZone: 'Zone de livraison par défaut',
    deliveryCountry: 'Pays de livraison *',
    deliveryCities: 'Villes de livraison *',
    add: 'Ajouter',
    selectCity: 'Sélectionner une ville',
    canAddMoreLater: 'Vous pourrez ajouter plus de villes et d\'adresses détaillées après l\'inscription',
    previous: 'Précédent',
    next: 'Suivant',
    creatingCompany: 'Création...',
    createMyCompany: 'Créer mon entreprise',
    registrationError: 'Erreur lors de l\'inscription',
    redirectingToSignIn: 'Votre compte est en attente d\'approbation par notre équipe. Vous recevrez un email dès son activation.',

    // ProfessionalLayout sidebar
    overviewMenu: 'Vue d\'ensemble',
    operationsSection: 'OPÉRATIONS',
    myPackagesMenu: 'Mes Colis',
    allPackages: 'Tous les colis',
    drafts: 'Brouillons',
    departuresMenu: 'Départs',
    deliveriesMenu: 'Livraisons',
    analysisSection: 'ANALYSE',
    statisticsMenu: 'Statistiques',
    financeMenu: 'Finance',
    managementSection: 'GESTION',
    broadcastMenu: 'Diffusion',
    teamMenu: 'Utilisateurs',
    auditLogMenu: 'Journal d\'audit',
    settingsMenu: 'Paramètres',
    usersMenu: 'Utilisateurs',
    companyMenu: 'Entreprise',
    subscriptionsMenu: 'Abonnements',
    adminMenu: 'Admin Plateforme',
    monitoringMenu: 'Monitoring',

    // ForcePasswordChange
    passwordChangeRequired: 'Changement de mot de passe requis',
    passwordChangeDesc: 'Pour votre sécurité, vous devez définir un nouveau mot de passe',
    accountSecurity: 'Sécurité de votre compte',
    yourEmail: 'Votre email',
    chooseNewPassword: 'Choisissez un nouveau mot de passe sécurisé',
    confirmNewPasswordPlaceholder: 'Confirmez votre mot de passe',
    changePasswordButton: 'Changer le mot de passe',
    changingPassword: 'Changement en cours...',
    passwordChangeError: 'Erreur lors du changement de mot de passe',
    loginError: 'Erreur de connexion. Veuillez réessayer.',

    // OnlineUsers
    offline: 'Hors ligne',
    online: 'En ligne',
    viewingDashboard: 'Consulte le tableau de bord',
    viewingPackages: 'Consulte les colis',
    viewingShipments: 'Consulte les départs',
    viewingAnalytics: 'Consulte les analyses',
    viewingSettings: 'Consulte les paramètres',
    editingPackage: 'Modifie un colis',
    editingShipment: 'Modifie un départ',
    creatingPackage: 'Crée un colis',
    creatingShipment: 'Crée un départ',
    justNow: 'À l\'instant',
    companyAdminRole: 'Admin Entreprise',
    countryAdminRole: 'Admin Pays',
    partnerRole: 'Partenaire',
    onlineUsersTitle: 'Utilisateurs en ligne',
    connectedUsers: 'connecté(s)',

    // ShipmentMonitoring
    monitoringLoadError: 'Erreur lors du chargement des données de surveillance',
    manualCheckError: 'Erreur lors de la vérification manuelle',

    // CookieConsent
    dataProtection: 'Protection de vos données',
    cookieMessage: 'FretManager utilise des cookies pour le bon fonctionnement du site et améliorer votre expérience.',
    cookieContinue: 'En continuant, vous acceptez notre',
    cookiePrivacyPolicy: 'politique de confidentialité',
    cookieAccept: 'Accepter',
    cookieAcceptAll: 'Tout accepter',
    cookieRefuse: 'Refuser',
    cookieManagePrefs: 'Gérer les préférences',
    cookieSavePrefs: 'Enregistrer',
    cookieEssential: 'Essentiels',
    cookieEssentialDesc: 'Nécessaires au fonctionnement du site (authentification, sécurité). Toujours actifs.',
    cookieAnalytics: 'Analytiques',
    cookieAnalyticsDesc: 'Nous aident à comprendre comment vous utilisez le site pour l\'améliorer.',
    cookieFunctional: 'Fonctionnels',
    cookieFunctionalDesc: 'Mémorisent vos préférences (thème, langue) pour personnaliser votre expérience.',

    // ConfirmDialog
    confirmation: 'Confirmation',
    actionIrreversible: 'Cette action est irréversible.',
    confirm: 'Confirmer',

    // NotificationBell
    noNotifications: 'Aucune notification',
    notifications: 'Notifications',

    // PackagePhotosDialog
    noPhotos: 'Aucune photo pour ce colis',

    // TrackPackage
    trackYourPackage: 'Suivre votre colis',
    packageNotFound: 'Colis non trouvé. Vérifiez le code OCE.',

    // ClientDashboard
    enterOceToTrack: 'Entrez votre code OCE pour suivre l\'état de votre envoi',
    enterOcePlaceholder: 'Entrez le code OCE (ex: OCE12345678)',
    searching: 'Recherche...',
    trackBtn: 'Suivre',
    packageDetails: 'Détails du colis',
    trackingHistory: 'Historique de suivi',
    aboutOceCode: 'À propos du code OCE',
    oceCodeDescription: 'Le code OCE vous est fourni lors de l\'enregistrement de votre colis. Conservez-le précieusement pour suivre votre envoi à tout moment.',

    // SuperAdminDashboard
    companyManagement: 'Gestion de l\'Entreprise',
    loadingData: 'Chargement...',
    unableToLoadData: 'Impossible de charger les données de gestion',
    errorLoadingData: 'Erreur lors du chargement des données de gestion',
    searchPackage: 'Rechercher un Colis',
    pendingPackages: 'Colis en Attente',
    unassigned: 'Non assignés',
    partnersInvolved: 'Partenaires Impliqués',
    withPendingPackages: 'Avec colis en attente',
    topDestinations: 'Destinations Principales',
    destinationCountries: 'Pays de destination',
    recommendation: 'Recommandation',
    urgent: 'URGENT',
    moderate: 'MODÉRÉ',
    wait: 'ATTENDRE',
    shipmentMonitoring: 'Surveillance Départs',
    flightApi: 'API Vols',
    usersTab: 'Utilisateurs',
    emailsTab: 'Emails',
    companySettings: 'Paramètres Entreprise',
    geographicManagement: 'Gestion Géographique',
    userManagement: 'Gestion des Utilisateurs',
    addUser: 'Ajouter un utilisateur',
    suspended: 'Suspendu',
    suspendUser: 'Suspendre',
    suspensionReason: 'Raison de la suspension',
    explainReason: 'Expliquez la raison...',
    durationDays: 'Durée (jours, vide = permanent)',
    cancel: 'Annuler',
    addUserTitle: 'Ajouter un Utilisateur',
    autoPassword: 'Un mot de passe temporaire sera généré automatiquement et envoyé par email. L\'utilisateur devra le changer lors de sa première connexion.',
    autoPasswordLabel: 'Mot de passe automatique :',
    name: 'Nom',
    email: 'Email',
    role: 'Rôle',
    phone: 'Téléphone',
    country: 'Pays',
    city: 'Ville',
    useCompanyCountry: 'Utiliser le pays de l\'entreprise',
    notDefined: 'Non défini',
    selectCity: 'Sélectionner une ville (optionnel)',
    unknownCity: 'Ville inconnue',
    unknownCountry: 'Pays inconnu',
    geoAssignment: 'Assignation Géographique',
    assignedZone: 'Zone géographique assignée',
    selectZone: 'Sélectionner une zone...',
    selectedZone: 'Zone sélectionnée :',
    countriesLabel: 'Pays',
    citiesLabel: 'Villes',
    allCities: 'Toutes les villes',
    none: 'Aucun',
    userCreatedSuccess: 'Utilisateur créé avec succès',
    tempPasswordGenerated: 'Mot de passe temporaire généré.',
    credentialsSent: 'Un email contenant les identifiants de connexion a été envoyé à l\'utilisateur.',
    invitationSent: 'Une invitation a été envoyée par email : le partenaire définira son mot de passe via le lien reçu.',
    invitationNotSentUseLink: "L'email n'a pas pu être envoyé. Transmettez ce lien d'activation au partenaire :",
    copy: 'Copier',
    pendingActivation: 'En attente d\'activation',
    resendInvitation: 'Renvoyer l\'invitation',
    invitationResent: 'Invitation renvoyée par email',
    createUser: 'Créer l\'utilisateur',
    emailNotifications: 'Gestion des Notifications Email',
    testEmail: 'Tester Email',
    emailServiceStatus: 'Statut du Service Email',
    service: 'Service',
    state: 'État',
    enabled: 'Activé',
    disabled: 'Désactivé',
    senderLabel: 'Expéditeur',
    emailNotConfigured: 'Le service email n\'est pas configuré. Ajoutez une clé API SendGrid dans les variables d\'environnement pour activer les notifications email automatiques.',
    emailNotifTypes: 'Types de Notifications Email',
    emailNotifDesc: 'Les emails sont envoyés automatiquement pour les événements suivants',
    emailOnCreation: 'Création de colis (si email expéditeur fourni)',
    emailOnCollected: 'Changement de statut : Collecté',
    emailOnTransit: 'Changement de statut : En transit',
    emailOnArrived: 'Changement de statut : Arrivé à destination',
    emailOnReady: 'Changement de statut : Prêt pour enlèvement',
    emailOnDelivered: 'Changement de statut : Livré',
    testEmailTitle: 'Tester l\'Envoi d\'Email',
    recipientEmail: 'Email Destinataire',
    subject: 'Sujet',
    message: 'Message',
    sending: 'Envoi...',
    send: 'Envoyer',
    testEmailSuccess: 'Email de test envoyé avec succès !',
    errorSendingEmail: 'Erreur lors de l\'envoi de l\'email de test',
    errorSuspending: 'Erreur lors de la suspension',
    errorUnsuspending: 'Erreur lors de la réactivation',
    errorAddingUser: 'Erreur lors de l\'ajout de l\'utilisateur',
    userSuspended: 'suspendu avec succès',
    userReactivated: 'réactivé avec succès',
    createdOn: 'Créé le',
    active: 'Active',
    inactive: 'Inactive',
    collectPartner: 'Partenaire Collecte',
    deliveryPartner: 'Partenaire Livraison',
    countryAdminRole: 'Admin Pays',
    companyAdminRole: 'Admin Entreprise',

    // NotFound
    notFoundDesc: 'La page que vous cherchez n\'existe pas ou a été déplacée.',

    // Dashboard
    roleNotRecognized: 'Rôle utilisateur non reconnu',

    // SettingsPage tabs
    profileTab: 'Profil',
    languageTab: 'Langue',
    notificationsTab: 'Notifications',
    securityTab: 'Sécurité',
    companyTab: 'Entreprise',
    billingTab: 'Facturation',

    // QRClientForm
    qrSessionNotFound: 'Session QR non trouvée ou invalide',
    qrSessionExpired: 'Session QR expirée ou déjà utilisée',
    qrLoadError: 'Erreur lors du chargement de la session',

    // Navbar landing
    trackAPackage: 'Suivre un colis',
    multiCountry: 'Multi-pays',
    help: 'Aide',
    freeTrial: 'Essai gratuit',

    // Hero landing
    heroTitle: 'Gérez votre fret international simplement',
    heroSubtitle: 'Suivi en temps réel, notifications automatiques, gestion multi-pays. Une plateforme unique pour piloter vos expéditions de bout en bout.',

    // Transport mode
    transportMode: 'Mode de transport',
    air: 'Aérien',
    maritime: 'Maritime',

    // Contact modal / page
    contactUs: 'Contactez-nous',
    ourTeamIsHere: 'Notre équipe est à votre écoute',
    sendUsMessage: 'Envoyez-nous un message',
    messageSent: 'Message envoyé !',
    willReplyIn24h: 'Nous vous répondrons sous 24h.',
    fullNamePlaceholder: 'Nom complet *',
    companyPlaceholder: 'Entreprise *',
    phonePlaceholder: 'Téléphone',
    yourMessage: 'Votre message...',
    sending: 'Envoi...',
    send: 'Envoyer',
    backToHome: 'Retour à l\'accueil',
    passwordRule: 'Au moins 8 caractères, une lettre et un chiffre.',
    hours: 'Horaires',
    hoursValue: 'Lun-Ven, 9h-18h CET',
    addressLabel: 'Adresse',

    // Privacy, Terms, Help - shared
    lastUpdated: 'Dernière mise à jour : 25 mai 2026',

    // Misc
    allRightsReserved: 'Tous droits réservés.',
    tip: 'Conseil',

    // ForcePasswordChange extras
    temporaryPasswordMsg: 'Votre compte utilise un mot de passe temporaire. Veuillez définir un mot de passe personnel sécurisé.',
    actionRequired: 'Action requise :',
    actionRequiredMsg: 'Vous devez changer votre mot de passe pour continuer à utiliser FretManager.',
    newPasswordLabel: 'Nouveau mot de passe',
    newPasswordPlaceholder: 'Entrez votre nouveau mot de passe',
    confirmNewPasswordLabel: 'Confirmer le nouveau mot de passe',
    confirmNewPasswordPlaceholder2: 'Confirmez votre nouveau mot de passe',
    passwordValid: 'Mot de passe valide',
    setNewPasswordButton: 'Définir mon nouveau mot de passe',
    passwordTipsTitle: 'Conseils pour un mot de passe sécurisé :',
    passwordTip1: 'Au moins 6 caractères',
    passwordTip2: 'Mélangez lettres, chiffres et symboles',
    passwordTip3: 'Évitez les mots de dictionnaire',
    passwordTip4: 'N\'utilisez pas d\'informations personnelles',

    // OnlineUsers extras
    noOtherUsersOnline: 'Aucun autre utilisateur en ligne',
    connectedSince: 'Connecté',
    viewingPage: 'Consulte une page',
    viewingResource: 'Consulte',
    editingResource: 'Modifie',
    editingData: 'Modifie des données',
    creatingResource: 'Crée un',
    creatingContent: 'Crée du contenu',

    // ShipmentMonitoring extras
    loadingMonitoring: 'Chargement des données de surveillance...',
    expectedArrival: 'Arrivée prévue',
    noTransitShipments: 'Aucun départ en transit actuellement',
    flightCheckError: 'Erreur lors de la vérification temps réel des vols',
    cronActive: 'Actif',
    cronStopped: 'Arrêté',
    notDefined: 'Non défini',
    manualCheckRunError: 'Erreur lors de l\'exécution de la vérification manuelle',
    flightApiError: 'Erreur API de vols',
    serviceUnavailable: 'Service indisponible',

    // PackageSearch extras
    searchPackage: 'Rechercher un Colis',
    searchPlaceholder: 'Code OCE, nom expéditeur/destinataire, email...',
    allFields: 'Tous les champs',
    oceCodeField: 'Code OCE',
    senderField: 'Expéditeur',
    recipientField: 'Destinataire',
    searchButton: 'Rechercher',
    statusLabel: 'Statut',
    allStatuses: 'Tous les statuts',
    startDate: 'Date début',
    endDate: 'Date fin',
    noPackageFound: 'Aucun colis trouvé pour',
    tryOtherSearch: 'Essayez avec un autre terme de recherche',
    resultsFound: 'résultat(s) trouvé(s)',
    enterSearchTerm: 'Entrez un terme de recherche ou utilisez les filtres',
    minCharsSearch: 'Minimum 2 caractères pour la recherche texte',
    weightLabel: 'Poids',
    createdLabel: 'Créé',
    shipmentDeparture: 'Départ',
    collectedBy: 'Collecté par',

    // PackagePhotosDialog extras
    photos: 'Photos',

    // CookieConsent extras
    cookieLearnMore: 'En savoir plus',
    closeCookie: 'Fermer',

    // Footer extras
    footerBrandDesc: 'Plateforme de gestion de fret international. Suivi, notifications, collaboration multi-acteurs.',

    // SettingsPage - Profile section
    personalInfo: 'Informations personnelles',
    role: 'R\u00f4le',
    assignedCountry: 'Pays assign\u00e9',

    // SettingsPage - Language section
    interfaceLanguageDesc: 'Langue d\'affichage de l\'interface',
    interfaceLanguage: 'Langue d\'interface',
    languageSavedAutomatically: 'La langue sera sauvegard\u00e9e automatiquement et appliqu\u00e9e sur toutes les pages.',

    // SettingsPage - Notifications section
    receiveNotifByEmail: 'Recevoir les notifications par email',
    receiveNotifByWhatsApp: 'Recevoir les notifications par WhatsApp',
    preferredNotifChannel: 'Canal de notification pr\u00e9f\u00e9r\u00e9',

    // SettingsPage - Security section
    passwordChangedSuccess: 'Mot de passe modifi\u00e9 avec succ\u00e8s',

    // SettingsPage - Company section
    companyGeneralConfig: 'Configuration g\u00e9n\u00e9rale de l\'entreprise',
    manageCompanyDesc: 'G\u00e9rez les param\u00e8tres de votre entreprise : pays, devises, transport, partenaires.',
    manageCompany: 'G\u00e9rer l\'entreprise',

    // SettingsPage - Billing section
    billingDesc: 'Num\u00e9rotation, taux de change, mod\u00e8le et images factures',
    invoiceTemplate: 'Mod\u00e8le de facture',
    invoiceTemplateDesc: 'Design et couleurs de vos factures',
    templateClassic: 'Classique',
    templateClassicDesc: 'Design professionnel standard',
    templateModern: 'Moderne',
    templateModernDesc: 'Barre \u00e9paisse, cartes arrondies',
    templateMinimal: 'Minimal',
    templateMinimalDesc: 'Sobre, bordures fines, fond blanc',
    templateBold: 'Bold',
    templateBoldDesc: 'Header plein couleur, texte large',
    saving: 'Sauvegarde...',
    preview: 'Aper\u00e7u',
    invoicePreview: 'Aper\u00e7u de la facture',
    settingsSaved: 'Param\u00e8tres sauvegard\u00e9s',
    saveError: 'Erreur lors de la sauvegarde',
    signatureUploaded: 'Signature import\u00e9e',
    stampUploaded: 'Cachet import\u00e9',
    uploadError: 'Erreur upload',
    previewLoadError: 'Erreur lors du chargement de l\'aper\u00e7u',
    numbering: 'Num\u00e9rotation',
    numberingDesc: 'Pr\u00e9fixe et client par d\u00e9faut',
    invoicePrefix: 'Pr\u00e9fixe de num\u00e9rotation',
    invoicePrefixExample: 'Exemple : FAC-2026-0001',
    defaultClient: 'Client par d\u00e9faut',
    defaultClientDesc: '\u00c0 qui la facture est adress\u00e9e par d\u00e9faut',
    exchangeRates: 'Taux de change',
    exchangeRatesDesc: 'Conversion EUR vers autres devises',
    leaveEmptyNoConversion: 'Laisser vide pour ne pas afficher la conversion',
    signatureAndStamp: 'Signature & Cachet',
    signatureAndStampDesc: 'Images affich\u00e9es sur les factures',
    signatureLabel: 'Signature (PNG/JPG)',
    stampLabel: 'Cachet (optionnel)',
    currencyXAF: 'Franc CFA (XAF)',
    currencyUSD: 'Dollar US (USD)',
    currencyGBP: 'Livre Sterling (GBP)',
    currencyCAD: 'Dollar Canadien (CAD)',
    companyLogo: 'Logo entreprise',
    companyLogoDesc: 'Apparaît sur les factures et les e-mails envoyés aux clients',
    noLogo: 'Aucun logo configuré',
    logoUploadHint: 'PNG, JPG, WebP ou SVG — max 2 Mo',
    logoUploadSuccess: 'Logo mis à jour',
    logoDeleted: 'Logo supprimé',

    // SettingsPage - Layout
    managePreferences: 'G\u00e9rez vos pr\u00e9f\u00e9rences et configurations',
    preferenceSaved: 'Pr\u00e9f\u00e9rence enregistr\u00e9e avec succ\u00e8s !',
    preferenceUpdateError: 'Erreur lors de la mise \u00e0 jour',
    personal: 'Personnel',
    administration: 'Administration',

    // QRClientForm extras
    qrSubmitError: 'Erreur lors de la soumission',
    invalidSession: 'Session Invalide',
    infoSent: 'Informations Envoy\u00e9es',
    infoTransmittedTo: 'Vos informations ont \u00e9t\u00e9 transmises \u00e0',
    willVerifyAndCreate: 'Ils vont v\u00e9rifier et cr\u00e9er votre colis.',
    willReceiveConfirmation: 'Vous recevrez un email de confirmation avec le code de suivi une fois le colis cr\u00e9\u00e9.',
    shipAPackage: 'Exp\u00e9dier un Colis',
    with: 'Avec',
    sessionExpiresOn: 'Session expire le',
    packageInfoTitle: 'Informations de votre Colis',
    packageInfoDesc: 'Remplissez tous les champs pour cr\u00e9er votre colis. Vous recevrez un email de confirmation.',
    yourInfoSender: 'Vos Informations (Exp\u00e9diteur)',
    trackingNotifToThisEmail: 'Vous recevrez les notifications de suivi \u00e0 cette adresse',
    recipientInfo: 'Informations Destinataire',
    recipientEmail: 'Email destinataire',
    merchandiseType: 'Type de marchandise',
    noCategory: 'Aucune cat\u00e9gorie',
    advance: 'Avanc\u00e9',
    advanceAmount: 'Montant avanc\u00e9',
    contentDescription: 'Description du contenu',
    describeContentForCustoms: 'D\u00e9crivez pr\u00e9cis\u00e9ment le contenu pour \u00e9viter les probl\u00e8mes douaniers',
    sendInfo: 'Envoyer les Informations',
    submitDisclaimer: 'En cliquant, vous acceptez que vos informations soient transmises au transporteur',

    // TermsOfService
    termsOfService: 'Conditions G\u00e9n\u00e9rales d\'Utilisation',
    tosPurpose: '1. Objet',
    tosServiceDescription: '2. Description du Service',
    tosRegistration: '3. Inscription & Compte',
    tosProhibitedUses: '4. Utilisations Interdites',
    tosLiability: '5. Responsabilit\u00e9',
    tosSubscriptions: '6. Abonnements & R\u00e9siliation',
    tosContact: '7. Contact',
    legalDepartment: 'Service juridique',

    // HelpCenter
    helpCenter: 'Centre d\'Aide',
    findAnswers: 'Trouvez des r\u00e9ponses \u00e0 vos questions',
    helpPackageManagement: 'Gestion des Colis',
    helpShipments: 'D\u00e9parts & Carr\u00e9aisons',
    helpRolesUsers: 'R\u00f4les & Utilisateurs',
    helpBilling: 'Facturation & Paiements',
    helpConfiguration: 'Configuration',
    helpNeedMore: 'Besoin d\'aide suppl\u00e9mentaire ?',
    contactSupport: 'Contactez notre support',
    responseTime24h: 'D\u00e9lai de r\u00e9ponse : sous 24h en jours ouvr\u00e9s',

    // PrivacyPolicy
    privacyPolicy: 'Politique de Confidentialit\u00e9',
    privacyDataCollected: '1. Donn\u00e9es Collect\u00e9es',
    privacyDataUsage: '2. Utilisation des Donn\u00e9es',
    privacyDataProtection: '3. Protection des Donn\u00e9es',
    privacyDataSharing: '4. Partage des Donn\u00e9es',
    privacyDataRetention: '5. Conservation des Donn\u00e9es',
    privacyYourRights: '6. Vos Droits',
    privacyContact: '7. Contact',
    responseTime30d: 'D\u00e9lai de r\u00e9ponse : 30 jours maximum',

    // CompanySettingsManager
    settingsLoadError: 'Erreur lors du chargement des paramètres',
    connectionErrorLoading: 'Erreur de connexion lors du chargement',
    settingsUpdatedSuccess: 'Paramètres mis à jour avec succès',
    settingsUpdateError: 'Erreur lors de la mise à jour',
    connectionErrorUpdating: 'Erreur de connexion lors de la mise à jour',
    loadingSettings: 'Chargement des paramètres...',
    cannotLoadCompanySettings: "Impossible de charger les paramètres de l'entreprise.",
    companyNamePlaceholder: 'Nom de votre entreprise',
    chooseCompanyType: "Choisir le type d'entreprise",
    transportModes: 'Modes de transport',
    selectTransportModes: 'Sélectionnez les modes de transport proposés par votre entreprise',
    seaFreight: 'Fret Maritime',
    airFreightShort: 'Aérien',
    seaFreightShort: 'Maritime',
    defaultMode: 'Mode par défaut',
    broadcastChannels: 'Canaux de diffusion (broadcast)',
    selectBroadcastChannels: 'Sélectionnez les canaux utilisés lors des diffusions vers les clients',
    inAppNotification: 'Notification In-App',
    yourCompanyPlaceholder: 'Votre Entreprise',
    currencyEur: 'EUR - Euro',
    currencyUsd: 'USD - Dollar',
    currencyXaf: 'XAF - Franc CFA',
    currencyGbp: 'GBP - Livre Sterling',
    currencyCad: 'CAD - Dollar Canadien',

    // GeographicSelector
    originCountryLabel: "Pays d'origine",
    destinationCountryLabel: 'Pays de destination',
    loadingCountries: 'Chargement des pays...',
    days: 'jours',
    cities: 'villes',
    originCityLabel: "Ville d'origine",
    destinationCityLabel: 'Ville de destination',
    selectCityOptional: 'Sélectionner une ville (optionnel)',
    deliveryIn: 'Livraison en',
    daysTo: 'jour(s) à',

    // GeographicManagement
    addDeliveryCountry: 'Ajouter un Pays de Livraison',
    countryNamePlaceholder: 'Nom du pays (ex: Cameroun)',
    countryCodePlaceholder: 'Code pays (ex: CM)',
    deliveryTimePlaceholder: 'Délai livraison (jours)',
    addCountryBtn: 'Ajouter le Pays',
    addCity: 'Ajouter une Ville',
    cityNamePlaceholder: 'Nom de la ville',
    cityCodePlaceholder: 'Code ville (ex: YAO)',
    addCityBtn: 'Ajouter la Ville',
    configuredDeliveryCountries: 'Pays de Livraison Configurés',
    customCountries: 'Pays Personnalisés',
    customCountriesDescription: 'Ajoutez des pays et villes supplémentaires qui apparaîtront dans les formulaires de création.',
    customCountryNamePlaceholder: 'Nom du pays (ex: Togo)',
    customCitiesPlaceholder: 'Villes séparées par virgule (ex: Lomé, Kara)',
    noCustomCountries: 'Aucun pays personnalisé ajouté.',
    createGeographicZone: 'Créer une Zone Géographique',
    zoneNamePlaceholder: 'Nom de la zone (ex: Cameroun - Centre)',
    countryWideZone: 'Zone pour tout le pays',
    createZoneBtn: 'Créer la Zone',
    configuredZones: 'Zones Configurées',
    wholeCountry: 'Pays entier',
    citiesLabel: 'Villes',
    localPartnersAssignments: 'LOCAL_PARTNER et leurs Assignations',
    zoneLabel: 'Zone',
    countryLabel: 'Pays',
    notAssigned: 'Non assignée',
    none: 'Aucun',
    noneF: 'Aucune',
    editAssignment: "Modifier l'assignation",
    assignToZone: 'Assigner à une zone...',
    wholeCountryOption: 'Pays entier...',
    loadingGeographicData: 'Chargement des données géographiques...',
    geographicManagement: 'Gestion Géographique',
    countriesAndCities: 'Pays & Villes',
    geographicZones: 'Zones Géographiques',
    localPartners: 'Partenaires Locaux',

    // MerchandiseCategoryManager
    cannotLoadCategories: 'Impossible de charger les catégories.',
    categoriesSaved: 'Catégories sauvegardées.',
    merchandiseCategories: 'Catégories de marchandise (supplément fixe)',
    noCategoriesConfigured: 'Aucune catégorie configurée. Cliquez sur "Ajouter" pour commencer.',
    fixedPrice: 'Prix fixe',
    currency: 'Devise',
    categoryNamePlaceholder: 'Ex: Téléphone, Électronique...',
    savingInProgress: 'Sauvegarde...',
    saveBtn: 'Sauvegarder',

    // RoutePricingGrid
    cannotLoadSettings: 'Impossible de charger les paramètres.',
    pricingSaved: 'Tarification sauvegardée.',
    routePricing: 'Tarification par route (prix/kg)',
    noRoutesConfigured: 'Aucune route configurée. Cliquez sur "Ajouter" pour commencer.',
    origin: 'Origine',
    destination: 'Destination',
    pricePerKg: 'Prix/kg',

    // FinancePage
    financeLoadError: 'Impossible de charger les données financières.',
    financeSaveSuccess: 'Données financières sauvegardées.',
    financeDetail: 'Détail financier',
    shipment: 'Départ',
    route: 'Route',
    totalWeight: 'Poids total',
    financeSummary: 'Résumé financier',
    totalRevenue: 'Revenu total',
    collectedRevenue: 'Revenu encaissé',
    debtUnpaid: 'Dette (non payé)',
    totalCharges: 'Total charges',
    profit: 'Profit',
    relatedPackages: 'Colis concernés',
    oceCode: 'Code OCE',
    price: 'Prix',
    payment: 'Paiement',
    chargesDetail: 'Détail des charges',
    notes: 'Notes',
    optionalRemarks: 'Remarques éventuelles...',
    settingsUpdated: 'Paramètres mis à jour.',
    defaultChargesSettings: 'Paramètres par défaut des charges',
    saveDefaults: 'Sauvegarder les défauts',
    shipmentsLoadError: 'Impossible de charger les départs.',
    noShipmentsDescription: 'Les données financières apparaîtront ici une fois les premiers départs créés',
    searchShipmentRoute: 'Rechercher départ, route...',
    revenue: 'Revenu',
    charges: 'Charges',
    marginPercent: 'Marge %',
    profitable: 'Rentable',
    unprofitable: 'Déficitaire',
    details: 'Détails',
    annualView: 'Vue annuelle',
    annualDataLoadError: 'Impossible de charger les données annuelles.',
    searchMonth: 'Rechercher un mois...',
    month: 'Mois',
    annualTotals: 'Totaux annuels',
    totalProfit: 'Profit total',
    totalDebt: 'Dette totale',
    shipmentsCount: 'Nb départs',
    profitableOnes: 'Rentables',
    paymentRecorded: 'Paiement enregistré',
    paymentError: 'Erreur paiement',
    sentVia: 'Envoyé via',
    sendFailed: 'Envoi échoué',
    sendError: 'Erreur envoi',
    pdfDownloadError: 'Erreur téléchargement PDF',
    all: 'Toutes',
    pending: 'En cours',
    settled: 'Soldées',
    searchInvoiceClient: 'Rechercher facture, client, code OCE...',
    noInvoiceFound: 'Aucune facture trouvée',
    invoiceNumber: 'N°',
    packageStatus: 'Statut colis',
    package: 'Colis',
    remaining: 'Reste',
    detail: 'Détail',
    invoice: 'Facture',
    associatedShipment: 'Départ associé',
    type: 'Type',
    paymentHistory: 'Historique des paiements',
    addPayment: 'Ajouter un paiement',
    amount: 'Montant',
    noteOptional: 'Note (optionnel)',
    recording: 'Enregistrement...',
    recordPayment: 'Enregistrer le paiement',
    downloadPdf: 'Télécharger PDF',
    sendToClient: 'Envoyer au client',
    netProfit: 'Profit net',
    debt: 'Dette',
    finance: 'Finance',
    financeSubtitle: 'Est-ce rentable pour nous ?',
    byShipment: 'Par Départ',
    invoices: 'Factures',
    pricing: 'Tarification',
    analysis: 'Analyse',

    // Invoice tab rework
    issuedThisMonth: 'Émises ce mois',
    collectedAmount: 'Encaissé',
    pendingAmount: 'En attente',
    overdueAmount: 'En retard',
    avgPaymentDelay: 'Délai moyen paiement',
    daysUnit: 'jours',
    debtAgingTitle: 'Vieillissement des créances',
    lessThan30d: '< 30j',
    between30and60d: '30-60j',
    between60and90d: '60-90j',
    moreThan90d: '> 90j',
    issuedOn: 'Émise le',
    dueDate: 'Échéance',
    paymentProgress: 'Paiement',
    overdueStatus: 'En retard',
    paidStatus: 'Payée',
    draftStatus: 'Brouillon',
    publicLink: 'Lien public',
    reminderBtn: 'Relancer',
    invoiceSummary: 'Résumé facture',
    billedTo: 'Facturé à',
    unitPriceHT: 'PU HT',
    quantity: 'QTÉ',
    totalHT: 'Total HT',
    designation: 'Désignation',
    subtotal: 'Sous-total',
    paidAmount: 'Payé',
    remainingDue: 'Reste dû',
    paymentOf: 'Paiement de',
    linkedShipment: 'Expédition liée',
    profitability: 'Rentabilité',
    margin: 'Marge',
    invoiceActions: 'Actions',
    noPaymentsYet: 'Aucun paiement enregistré',
    overdueFilter: 'En retard',
    allInvoices: 'Toutes',
    paidFilter: 'Payées',
    pendingFilter: 'En attente',
    invoiceCount: 'factures',
    weightLabel: 'Poids',

    // CountryAdminDashboard
    countryAdminDashboard: 'Tableau de bord - Administrateur Pays',
    totalPackages: 'Total Colis',
    partners: 'Partenaires',
    inTransit: 'En Transit',
    recentPackages: 'Colis récents',
    manageCountryPackages: 'Gérez tous les colis de votre pays',

    // UnifiedDashboard
    minutesAgo: 'Il y a {n}min',
    hoursAgo: 'Il y a {n}h',
    daysAgo: 'Il y a {n}j',
    activityNew: 'Nouveau',
    activityUpdated: 'Mis à jour',
    activityShipment: 'Départ',
    activityPhoto: 'Photo',
    activityUser: 'Utilisateur',
    activityAction: 'Action',
    deliveredPackages: 'Colis livrés',
    overdueInvoices7d: 'Factures impayées 7j+',
    awaitingCustomsClearance: 'En attente dédouanement',
    reportedIncidents: 'Incidents signalés',
    noUpdate3d: 'Sans mise à jour 3j+',
    hello: 'Bonjour',
    updatedJustNow: "Mis à jour à l'instant",
    pendingPackages: 'Colis en attente',
    activePartners: 'Partenaires actifs',
    withPendingPackages: 'Ayant des colis en attente',
    destinations: 'Destinations',
    destinationCountries: 'Pays de destination',
    recommendation: 'Recommandation',
    newShipment: 'Nouveau Départ',
    viewAnalytics: 'Voir Analytics',
    topDestinations: 'Top Destinations',
    viewAll: 'Voir tout',
    noRecentActivity: 'Aucune activité récente',

    // AnalysisDashboard
    periodAnalysis: 'Analyse par période',
    periodAnalysisDesc: 'Évolution cumulée des revenus et charges sur une période donnée',
    routeProfitability: 'Rentabilité par route',
    routeProfitabilityDesc: "Profit et marge par route d'expédition",
    debtAging: 'Vieillissement des créances',
    debtAgingDesc: 'Factures impayées classées par ancienneté',
    paymentMethodAnalysis: 'Moyens de paiement',
    paymentMethodAnalysisDesc: 'Répartition des moyens de paiement utilisés',
    chargeBreakdown: 'Répartition des charges',
    chargeBreakdownDesc: 'Distribution des différents types de charges',

    // PlatformMonitoringPage
    sevenDays: '7 jours',
    thirtyDays: '30 jours',
    statsLoadError: 'Erreur lors du chargement des statistiques',
    logins: 'Connexions',
    pageViews: 'Pages vues',
    uniqueUsers: 'Utilisateurs uniques',
    sessions: 'Sessions',
    activeUsersLabel: 'utilisateurs actifs',
    noLoginsInPeriod: 'Aucune connexion sur cette période',
    noPageViewsInPeriod: 'Aucune page vue sur cette période',
    mostVisitedPages: 'Pages les plus visitées',
    views: 'Vues',
    devices: 'Appareils',
    countries: 'Pays',
    unknown: 'Inconnu',
    totalSessions: 'Sessions totales',
    averageDuration: 'Durée moyenne',
    pagesPerSession: 'Pages / session',
    pageDetails: 'Détails par page',
    uniqueVisitors: 'Visiteurs uniques',

    // PlatformAdminPage
    platformAdmin: 'Admin Plateforme',
    platformAdminDesc: 'Gestion centralisée de toutes les entreprises',
    companies: 'Entreprises',
    subscriptions: 'Abonnements',
    incidents: 'Incidents',
    activeUsers: 'Utilisateurs Actifs',
    packagesThisMonth: 'Colis ce mois',
    openIncidents: 'incidents ouverts',
    totalShipmentsOnPlatform: 'Départs totaux sur la plateforme',
    allRegisteredPackages: 'Tous les colis enregistrés',
    allCompanies: 'Toutes les entreprises',
    code: 'Code',
    contact: 'Contact',
    actions: 'Actions',
    suspend: 'Suspendre',
    activate: 'Activer',
    noCompanies: 'Aucune entreprise',
    searchNameOrEmail: 'Rechercher nom ou email...',
    allRoles: 'Tous les rôles',
    results: 'résultats',
    totalSubscriptions: 'Total abonnements',
    plan: 'Plan',
    period: 'Période',
    noSubscriptions: 'Aucun abonnement',
    acknowledged: 'Pris en compte',
    resolved: 'Résolu',
    closed: 'Fermé',
    allCategories: 'Toutes les catégories',
    category: 'Catégorie',
    reportedBy: 'Signalé par',
    date: 'Date',
    resolve: 'Résoudre',
    noIncidents: 'Aucun incident',
    confirmSuspendCompany: "Suspendre l'entreprise ?",
    confirmActivateCompany: "Réactiver l'entreprise ?",
    confirmDeleteCompany: "Supprimer l'entreprise ?",
    confirmSuspendDesc: 'Tous les utilisateurs de "{name}" seront désactivés.',
    confirmActivateDesc: 'Les utilisateurs de "{name}" seront réactivés.',
    confirmDeleteDesc: '"{name}" sera supprimée (soft-delete). Cette action est irréversible.',
    approve: 'Valider',
    confirmApproveCompany: "Valider l'entreprise ?",
    confirmApproveDesc: 'L\'entreprise "{name}" sera activée et ses utilisateurs pourront se connecter.',
    companyApproved: 'Entreprise validée',
    errorApproval: 'Erreur lors de la validation',
    editSubscription: "Modifier l'abonnement",
    resolveIncident: "Résoudre l'incident",
    resolutionNote: 'Note de résolution',
    describeResolution: 'Décrivez la résolution...',
    errorLoadingAnalytics: 'Erreur chargement analytics',
    errorLoadingCompanies: 'Erreur chargement entreprises',
    errorLoadingUsers: 'Erreur lors du chargement des utilisateurs',
    errorLoadingSubscriptions: 'Erreur chargement abonnements',
    errorLoadingIncidents: 'Erreur chargement incidents',
    companySuspended: 'Entreprise suspendue',
    errorSuspension: 'Erreur suspension',
    companyReactivated: 'Entreprise réactivée',
    errorActivation: 'Erreur activation',
    companyDeleted: 'Entreprise supprimée',
    errorDeletion: 'Erreur suppression',
    subscriptionUpdated: 'Abonnement mis à jour',
    incidentResolved: 'Incident résolu',
    errorResolution: 'Erreur résolution',

    // AuditLogPage
    entityUser: 'Utilisateur',
    entityPackage: 'Colis',
    entityShipment: 'Départ',
    entityCompany: 'Entreprise',
    accessDenied: 'Accès refusé',
    adminOnlyPage: 'Cette page est réservée aux administrateurs.',
    auditLogsDesc: 'Historique de toutes les actions effectuées dans le système',
    entityType: "Type d'entité",
    entries: 'entrées',
    entry: 'entrée',
    noLogs: 'Aucun log',
    noLogsForFilters: 'Aucune action enregistrée pour les filtres sélectionnés',
    user: 'Utilisateur',
    action: 'Action',
    entity: 'Entité',

    // TeamOrgChartSections
    headquarters: 'Siège',
    delivery: 'Livraison',
    headquartersAndDelivery: 'Siège & Livraison',
    errorFetchingMembers: 'Erreur lors de la récupération des membres',
    errorCreatingUser: 'Erreur lors de la création',
    selectCountryAndRole: 'Veuillez sélectionner un pays et un rôle',
    errorAssigningCountry: "Erreur lors de l'assignation",
    reactivation: 'Réactivation',
    suspendedByAdmin: "Suspendu par l'administrateur",
    errorStatusChange: 'Erreur lors de la modification du statut',
    noName: 'Sans nom',
    orgChartBySection: 'Organigramme par Section',
    members: 'membres',
    member: 'membre',
    inYourTeam: 'dans votre équipe',
    addMember: 'Ajouter un membre',
    shippingCountriesHQ: "Pays d'Expédition (Sièges)",
    allShippingCountries: "Tous les pays d'expédition",
    destinationCountriesDelivery: 'Pays de Destination (Livraison)',
    allDestinationCountries: 'Tous les pays de destination',
    membersFound: 'membres trouvés',
    memberFound: 'membre trouvé',
    generalManagement: 'Direction Générale',
    countryAdministration: 'Administration Pays',
    collectors: 'Collecteurs',
    deliveryPartners: 'Livreurs',
    memberDetails: 'Détails du membre',
    detailedInfoAbout: 'Informations détaillées sur',
    accountSuspended: 'Compte suspendu',
    accountActive: 'Compte actif',
    viewActivity: "Voir l'activité",
    countryAssignment: 'Assignation au Pays',
    current: 'Actuel',
    headquartersShipping: 'Sièges (Expédition)',
    deliveryCountries: 'Pays de Livraison',
    selectType: 'Sélectionner un type',
    assigning: 'Assignation...',
    assignToCountry: 'Assigner au pays',
    processing: 'Traitement...',
    reactivateAccount: 'Réactiver ce compte',
    suspendAccount: 'Suspendre ce compte',
    addTeamMember: "Ajouter un Membre d'Équipe",
    fillInfoToCreateMember: 'Remplissez les informations pour créer un nouveau membre.',
    minCharsPassword: 'Min. 8 caractères',
    collectionPartner: 'Partenaire Collecte',
    deliveryPartner: 'Partenaire Livraison',
    assignToShippingCountry: "Assignation au Pays d'Expédition (Siège)",
    assignToDeliveryCountry: 'Assignation au Pays de Destination (Livraison)',
    createMember: 'Créer le membre',
    teamActiveMembers: 'Membres actifs',
    teamSuspendedMembers: 'Suspendus',
    teamAdmins: 'Administrateurs',
    teamPartners: 'Partenaires',
    searchMembers: 'Nom, email, rôle...',
    filterAll: 'Tous',
    filterAdmins: 'Admin',
    filterCollectors: 'Collecteurs',
    filterDelivery: 'Livreurs',
    filterClients: 'Clients',
    noMembersInFilter: 'Aucun membre trouvé pour ce filtre',
    tabUsers: 'Utilisateurs',
    tabTeam: 'Équipe',
    tabRoles: 'Rôles & Permissions',
    columnUser: 'Utilisateur',
    columnRole: 'Rôle',
    columnScope: 'Périmètre',
    columnStatus: 'Statut',
    statusActive: 'Actif',
    statusSuspended: 'Suspendu',
    noAssignment: 'Non assigné',
    rolesIntro: 'Rôles disponibles dans votre organisation',
    roleSuperAdminDesc: 'Accès complet à toutes les fonctionnalités et paramètres',
    roleCompanyAdminDesc: "Gestion de l'entreprise, utilisateurs et paramètres",
    roleCountryAdminDesc: "Administration d'un pays spécifique (expédition ou livraison)",
    rolePartnerDesc: 'Collecte des colis dans un pays de départ',
    roleLocalPartnerDesc: 'Livraison des colis dans un pays de destination',
    roleClientDesc: 'Client qui envoie des colis via la plateforme',
    permissionsCount: 'permissions',
    membersWithRole: 'membres',
    tabClients: 'Clients',
    clientsSubtitle: 'Base de données expéditeurs & récepteurs',
    permFull: 'Complet',
    permEdit: 'Édition',
    permRead: 'Lecture',
    permScope: 'Périmètre',
    permSelf: 'Soi-même',
    permNone: '—',
    permModule: 'Module',
    modShipments: 'Expéditions',
    modPackages: 'Colis',
    modFinance: 'Finance',
    modUsers: 'Utilisateurs',
    modPartners: 'Partenaires',
    modSettings: 'Paramètres',
    modTracking: 'Suivi',

    // UsersManagement
    usersManagement: 'Gestion des Utilisateurs',
    newUser: 'Nouvel Utilisateur',
    userCreatedSuccess: 'Utilisateur créé avec succès !',
    select: 'Sélectionner',
    errorDeletingUser: 'Erreur lors de la suppression',
    errorEditingUser: 'Erreur lors de la modification',

    // FlightAPITester
    enterFlightNumber: 'Veuillez saisir un numéro de vol',
    flightApiUnavailable: 'Service API de vols indisponible',
    errorSearching: 'Erreur lors de la recherche',
    flightApiConnectionError: "Erreur de connexion à l'API de vols",
    flight: 'Vol',
    generalInfo: 'Informations générales',
    airline: 'Compagnie',
    notSpecified: 'Non spécifié',
    schedules: 'Horaires',
    scheduledDeparture: 'Départ prévu',
    actualDeparture: 'Départ réel',
    scheduledArrival: 'Arrivée prévue',
    estimatedArrival: 'Arrivée estimée',
    actualArrival: 'Arrivée réelle',
    airportInfo: 'Informations aéroport',

    // Pagination
    showingResults: 'Affichage de {start} à {end} sur {total} résultats',
    rowsPerPage: 'Lignes par page :',

    // RealTimeNotifications
    newPlural: 'nouvelles',
    newSingular: 'nouvelle',
    markAllAsRead: 'Tout marquer comme lu',
    deleteRead: 'Supprimer les lues',

    // CompanyInfoDynamic
    errorFetching: 'Erreur lors de la récupération',
    errorSaving: 'Erreur lors de la sauvegarde',
    noSettingsFound: 'Aucun paramètre trouvé',
    freightForwarder: 'Transitaire',
    carrier: 'Transporteur',
    logisticsProvider: 'Prestataire Logistique',
    companyInfoLabel: "Informations de l'Entreprise",
    companyInfoDesc: 'Vue complète et configuration de votre entreprise',
    settingsSavedSuccess: 'Informations sauvegardées avec succès !',
    generalInformation: 'Informations Générales',
    companyNameAndType: "Nom et type d'entreprise",
    headquartersConfiguredPlural: 'sièges configurés',
    headquartersConfiguredSingular: 'siège configuré',
    noHeadquartersConfigured: 'Aucun siège configuré',
    addHeadquarter: 'Ajouter un siège',
    selectCountryHQ: 'Sélectionner un pays (siège)',
    headquarterAddress: 'Adresse du siège',
    countriesConfiguredPlural: 'pays configurés',
    countriesConfiguredSingular: 'pays configuré',
    noDeliveryCountriesConfigured: 'Aucun pays de livraison configuré',
    addCountry: 'Ajouter un pays',
    pickupAddress: 'Adresse de retrait',
    addAdditionalCountry: 'Ajouter un pays supplémentaire',
    routesAndTransit: 'Routes & Transit',
    transitDurationsAndRates: 'Durées de transit et tarifs par route',
    transitDays: 'Transit (jours)',
    transitDurationsByRoute: 'Durées de transit par route',
    noTransitConfig: 'Aucune configuration de transit.',
    routePricingNote: 'Les tarifs par route se configurent dans Finance > Tarification.',

    // BroadcastPage
    broadcastDesc: 'Envoyer des messages groupés à vos clients',
    newMessage: 'Nouveau message',
    history: 'Historique',
    composeMessage: 'Composer un message',
    subject: 'Sujet',
    messageSubjectPlaceholder: 'Objet du message...',
    message: 'Message',
    messageContentPlaceholder: 'Contenu du message...',
    sendingChannels: "Canaux d'envoi",
    recipients: 'Destinataires',
    byCountry: 'Par pays',
    clients: 'Clients',
    byShipmentFilter: 'Par départ',
    selectShipment: 'Sélectionner un départ',
    recipientsPreview: 'Aperçu des destinataires',
    confirmSending: "Confirmer l'envoi",
    channels: 'Canaux',
    target: 'Cible',
    allContacts: 'Tous les contacts',
    irreversibleAction: 'Cette action est irréversible. Les messages seront envoyés immédiatement.',
    errorPreview: "Erreur lors de l'aperçu",
    broadcastLaunched: 'Diffusion lancée ! {count} destinataires.',
    errorSending: "Erreur lors de l'envoi",
    inProgress: 'En cours',
    sent: 'Envoyé',
    partial: 'Partiel',
    failed: 'Échoué',
    noBroadcastsSent: 'Aucune diffusion envoyée.',
    loadingRecipients: 'Chargement des destinataires...',
    sendingInProgress: 'Envoi en cours...',
    noRecipientsRegistered: 'Aucun destinataire enregistré',

    // Pricing ContactModal
    requestSent: 'Demande envoyée !',
    teamWillContact: 'Notre équipe vous contactera sous 24h pour planifier votre rendez-vous.',
    bookAppointment: 'Prendre rendez-vous',
    enterprisePlanContact: 'Plan Entreprise — notre équipe vous recontacte sous 24h',
    professionalEmail: 'Email professionnel *',
    tellUsYourNeeds: 'Parlez-nous de vos besoins (optionnel)',
    sendMyRequest: 'Envoyer ma demande',

    // Points Relais / Delivery Mode
    relayPoints: 'Points Relais',
    relayPoint: 'Point Relais',
    relayPointName: 'Nom du point relais',
    relayPointAddress: 'Adresse',
    relayPointCity: 'Ville',
    relayPointPhone: 'Téléphone',
    relayPointOpeningHours: 'Horaires d\'ouverture',
    addRelayPoint: 'Ajouter un point relais',
    deleteRelayPoint: 'Supprimer ce point relais',
    selectRelayPoint: 'Sélectionner un point relais',
    relayPointPickup: 'Retrait en point relais',
    openingHours: 'Horaires',
    deliveryMode: 'Mode de livraison',
    assignDeliveryMode: 'Assigner mode de livraison',
    homeDelivery: 'Livraison à domicile',
    homeDeliveryDesc: 'Le colis sera livré directement au destinataire',
    relayPointDesc: 'Le destinataire viendra récupérer son colis au point relais',
    deliveryModeAssigned: 'Mode de livraison assigné avec succès',
    errorAssigningDeliveryMode: 'Erreur lors de l\'assignation du mode de livraison',
    noRelayPointsConfigured: 'Aucun point relais configuré',
    relayPointInfo: 'Informations du point relais',
    depositRelayPoint: 'Déposer en point relais',
    depositRelayPointDesc: 'Déposer le colis dans un point relais pour retrait par le destinataire',
    confirmDeposit: 'Confirmer le dépôt',
    depositSuccess: 'Colis déposé en point relais avec succès',
    errorDeposit: 'Erreur lors du dépôt en point relais',
    atRelayPoint: 'En point relais',
    depositNotes: 'Notes de dépôt',
    deliveryHistory: 'Historique des livraisons',
    noDeliveryHistory: 'Aucune livraison effectuée',
    refresh: 'Actualiser',
    confirm: 'Confirmer',

    // SEO
    seoLandingTitle: 'Solution de gestion de fret international',
    seoLandingDesc: 'Plateforme de gestion de fret international. Suivi en temps réel, gestion des expéditions, notifications automatiques.',
    seoTrackTitle: 'Suivre mon colis | FretManager',
    seoTrackDesc: 'Suivez votre colis en temps réel. Entrez votre code de suivi pour connaître le statut de votre expédition.',
    seoContactTitle: 'Contact | FretManager',
    seoContactDesc: 'Contactez l\'équipe FretManager. Demandez une démonstration ou posez vos questions sur notre plateforme de gestion de fret.',
    seoHelpTitle: 'Centre d\'aide | FretManager',
    seoHelpDesc: 'Trouvez des réponses à vos questions sur FretManager. Guides d\'utilisation, FAQ et support technique.',
    seoPrivacyTitle: 'Politique de confidentialité | FretManager',
    seoPrivacyDesc: 'Découvrez comment FretManager protège vos données personnelles et respecte votre vie privée.',
    seoTermsTitle: 'Conditions d\'utilisation | FretManager',
    seoTermsDesc: 'Consultez les conditions générales d\'utilisation de la plateforme FretManager.',
    seoLoginTitle: 'Connexion | FretManager',
    seoLoginDesc: 'Connectez-vous à votre espace FretManager pour gérer vos expéditions.',
    seoRegisterTitle: 'Inscription | FretManager',
    seoRegisterDesc: 'Créez votre compte FretManager et commencez à gérer vos expéditions internationales.',
    seoDashboardTitle: 'Dashboard | FretManager',
    seoDashboardDesc: 'Tableau de bord FretManager — gestion de vos expéditions et colis.',
  },

  en: {
    // Navigation & Header
    dashboard: 'Dashboard',
    users: 'Users',
    packages: 'Packages',
    shipments: 'Shipments',
    analytics: 'Analytics',
    settings: 'Settings',
    logout: 'Logout',
    login: 'Login',
    createCompany: 'Create My Company',
    trackPackage: 'Track Package',
    
    // Landing Page - Hero Section
    landingHeroBadge: '🌍 Revolutionize Your International Transport',
    landingHeroTitle: 'FretManager',
    landingHeroSubtitle: 'Transform your transport business with a solution that simplifies operations, builds customer loyalty and boosts growth',
    landingHeroSubtitleBold1: 'Transform your transport business',
    landingHeroSubtitleBold2: 'simplifies operations',
    landingHeroSubtitleBold3: 'builds customer loyalty',
    landingHeroSubtitleBold4: 'boosts growth',
    landingChallengesTitle: '🎯 FretManager solves your daily challenges',
    landingChallenge1: 'Costly input errors',
    landingChallenge2: 'Customers waiting for updates',
    landingChallenge3: 'Time-consuming manual management',
    landingSolution1: 'Autonomous clients with QR codes',
    landingSolution2: 'Automatic notifications 24/7',
    landingSolution3: 'Smart dashboard',
    landingCtaFree: 'Free Trial - $0',
    landingCtaTrack: 'Track Package',
    
    // Landing Page - Stats
    landingStatsTitle: '🏆 Immediate business impact for your company',
    landingStat1Value: '-75%',
    landingStat1Label: 'Input errors',
    landingStat2Value: '+60%',
    landingStat2Label: 'Customer satisfaction',
    landingStat3Value: '-50%',
    landingStat3Label: 'Processing time',
    landingStat4Value: '24/7',
    landingStat4Label: 'Automatic tracking',
    
    // Landing Page - Business Benefits
    landingBenefitsTitle: 'Why companies choose FretManager?',
    landingBenefitsSubtitle: 'Beyond technology, we help you build a more human and profitable transport business',
    landingProblemsTitle: '🔴 Your current challenges speak to us',
    landingProblem1Title: '😰 "My customers call me constantly"',
    landingProblem1Desc: 'They want to know where their packages are, when they\'ll arrive... Your phone never stops ringing.',
    landingProblem2Title: '😤 "Errors cost me dearly"',
    landingProblem2Desc: 'Wrong addresses, lost packages, unhappy customers... Input errors waste your time and money.',
    landingProblem3Title: '😵 "I\'m drowning in paperwork"',
    landingProblem3Desc: 'Excel files, notebooks, sticky notes... Your office looks like an administrative battlefield.',
    landingSolutionsTitle: '✅ With FretManager, finally breathe',
    landingSolution1Title: '😌 "My customers are automatically informed"',
    landingSolution1Desc: 'Professional emails sent at every step. Your customers always know where their package stands.',
    landingSolution2Title: '😊 "Zero input errors"',
    landingSolution2Desc: 'Your customers scan a QR code and enter their information themselves. No more errors!',
    landingSolution3Title: '🎯 "Everything is centralized and simple"',
    landingSolution3Desc: 'A clear dashboard, organized shipments, meaningful statistics. Finally time for your business!',
    
    // Landing Page - ROI Calculator
    landingRoiTitle: '💰 Calculate your return on investment',
    landingRoi1Value: '2h/day',
    landingRoi1Label: 'saved on paperwork',
    landingRoi2Value: '×3',
    landingRoi2Label: 'more satisfied customers',
    landingRoi3Value: '-80%',
    landingRoi3Label: 'complaint calls',
    landingRoiProfit: 'For a 50 packages/week business: +$18,000/year profit',
    
    // Landing Page - Features
    landingFeaturesTitle: 'Advanced Features',
    landingFeaturesSubtitle: 'FretManager integrates the latest technologies for optimal user experience',
    landingFeature1Title: 'Dedicated company workspace',
    landingFeature1Desc: 'Run your whole operation from one place: teams, partners and departures, in a private and secure workspace.',
    landingFeature1Benefit1: 'Private, secure workspace',
    landingFeature1Benefit2: 'Roles and permissions per team',
    landingFeature1Benefit3: 'Ready to scale with you',
    landingFeature2Title: 'Autonomous Client QR Code',
    landingFeature2Desc: 'Clients scan a QR code and enter their information directly. No more partner input errors!',
    landingFeature2Benefit1: 'Direct client input',
    landingFeature2Benefit2: 'Error reduction',
    landingFeature2Benefit3: 'Partner time savings',
    landingFeature3Title: 'Automatic Email Notifications',
    landingFeature3Desc: 'Professional automatic emails with SendGrid: shipping confirmation, status tracking, delivery alerts.',
    landingFeature3Benefit1: 'Professional templates',
    landingFeature3Benefit2: 'Arrival estimation',
    landingFeature3Benefit3: 'Automatic tracking',
    landingFeature4Title: 'Multilingual Support',
    landingFeature4Desc: 'Interface available in French and English. Instant language switching for international users.',
    landingFeature4Benefit1: 'French / English',
    landingFeature4Benefit2: 'Instant switching',
    landingFeature4Benefit3: 'Adapted interface',
    landingFeature5Title: 'Payment Management',
    landingFeature5Desc: 'Simple payment status tracking (Paid/Unpaid) with visual indicators in all interfaces.',
    landingFeature5Benefit1: 'Clear visual status',
    landingFeature5Benefit2: 'Accounting tracking',
    landingFeature5Benefit3: 'Unpaid alerts',
    landingFeature6Title: 'Real-time & WebSockets',
    landingFeature6Desc: 'Real-time notifications, connected users, instant package status updates.',
    landingFeature6Benefit1: 'Instant notifications',
    landingFeature6Benefit2: 'Online users',
    landingFeature6Benefit3: 'Live synchronization',
    landingFeaturePremium: 'Premium Feature',
    
    // Landing Page - User Roles
    landingRolesTitle: 'User Roles',
    landingRolesSubtitle: 'An adapted interface for each type of user',
    landingRoleSuperAdmin: 'Super Admin',
    landingRoleSuperAdminDesc: 'Complete company management, users, shipments',
    landingRoleSuperAdminFeature1: 'Company creation',
    landingRoleSuperAdminFeature2: 'User management',
    landingRoleSuperAdminFeature3: 'Complete analytics',
    landingRoleCountryAdmin: 'Country Admin',
    landingRoleCountryAdminDesc: 'Country administration, local partner management',
    landingRoleCountryAdminFeature1: 'Country partner management',
    landingRoleCountryAdminFeature2: 'Regional shipments',
    landingRoleCountryAdminFeature3: 'Country statistics',
    landingRolePartnerCollection: 'Collection Partner',
    landingRolePartnerCollectionDesc: 'Package collection, QR code generation, shipment management',
    landingRolePartnerCollectionFeature1: 'Client QR Code',
    landingRolePartnerCollectionFeature2: 'Package management',
    landingRolePartnerCollectionFeature3: 'Shipments view',
    landingRolePartnerDelivery: 'Delivery Partner',
    landingRolePartnerDeliveryDesc: 'Local delivery, OCE validation, GPS confirmation',
    landingRolePartnerDeliveryFeature1: 'Delivery validation',
    landingRolePartnerDeliveryFeature2: 'OCE scan',
    landingRolePartnerDeliveryFeature3: 'Geolocation',
    landingRoleClient: 'Client',
    landingRoleClientDesc: 'Package tracking, shipment history',
    landingRoleClientFeature1: 'Package tracking',
    landingRoleClientFeature2: 'History',
    landingRoleClientFeature3: 'Notifications',
    
    // Landing Page - Testimonials
    landingTestimonialsTitle: 'They transformed their business with FretManager',
    landingTestimonialsSubtitle: 'Entrepreneurs like you share their experience',
    landingTestimonial1Author: 'Marie Diallo',
    landingTestimonial1Company: 'Express Sahel Transport',
    landingTestimonial1Text: '"My customers love being able to scan the QR code and enter their information themselves. No more errors, no more callbacks! My revenue increased by 40% in 6 months."',
    landingTestimonial1Impact: '+40% revenue • -90% input errors',
    landingTestimonial2Author: 'Amadou Kouassi',
    landingTestimonial2Company: 'Logistics Côte d\'Or',
    landingTestimonial2Text: '"Before, I spent 3h a day doing customer follow-up. Now, emails are sent automatically. I can finally focus on growing my business!"',
    landingTestimonial2Impact: '-75% administrative time • +25 new customers',
    landingTestimonial3Author: 'Fatima Ben Ali',
    landingTestimonial3Company: 'Maghreb Fret Express',
    landingTestimonial3Text: '"The multilingual interface is perfect for my French and Arabic clients. Shipment management is so simple that even my 16-year-old son can help me!"',
    landingTestimonial3Impact: '2 languages • Family training in 2h',
    landingTestimonialsRating: '🏆 Average rating: 4.9/5 (127 reviews)',
    landingTestimonialsTagline: '"The most complete and easy-to-use solution on the market"',
    landingTestimonialsBenefits: '24h installation • French support • Training included',
    
    // Landing Page - Technology
    landingTechTitle: 'Modern Technologies',
    landingTechPerformanceTitle: 'Performance',
    landingTechPerformanceDesc: 'FastAPI + React + MongoDB for optimal performance',
    landingTechSecurityTitle: 'Security',
    landingTechSecurityDesc: 'JWT, multi-tenant isolation, complete audit trail',
    landingTechRealtimeTitle: 'Real-time',
    landingTechRealtimeDesc: 'WebSockets for notifications and instant updates',
    
    // Landing Page - CTA Final
    landingCtaTitle: 'Start Your Transformation Today',
    landingCtaSubtitle: 'Join the visionary entrepreneurs who chose to modernize their transport',
    landingCtaBenefit1Title: 'Quick Start',
    landingCtaBenefit1Desc: 'Operational in less than 24h',
    landingCtaBenefit2Title: 'Training Included',
    landingCtaBenefit2Desc: 'Personalized support',
    landingCtaBenefit3Title: 'Guaranteed Results',
    landingCtaBenefit3Desc: 'Visible ROI from month 1',
    landingCtaButton1: 'Start Free - $0',
    landingCtaButton2: 'I Already Have an Account',
    landingCtaGuarantees: 'No commitment • Free setup • 24/7 support',
    
    // Landing Page - Footer
    landingFooterDesc: 'International transport management platform - Version 1.0.0',
    landingFooterCopyright: '© 2024 FretManager • International Transport • Multi-tenant Platform',
    
    // Colis & Package Management
    createPackage: 'Create Package',
    packageCode: 'Package Code',
    sender: 'Sender',
    recipient: 'Recipient',
    recipientName: 'Recipient Name',
    recipientPhone: 'Recipient Phone',
    weight: 'Weight',
    description: 'Description',
    originCountry: 'Origin Country',
    destinationCountry: 'Destination Country',
    status: 'Status',
    paymentStatus: 'Payment Status',
    isPaid: 'Paid',
    senderEmail: 'Sender Email',
    
    // Shipments & Flight Management
    createShipment: 'Create Shipment',
    flightName: 'Flight Name',
    flightNumber: 'Flight Number',
    expectedArrivalDate: 'Expected Arrival Date',
    actualArrivalDate: 'Actual Arrival Date',
    departureDate: 'Departure Date',
    shipmentMonitoring: 'Shipment Monitoring',
    delayedShipments: 'Delayed Shipments',
    arrivingSoon: 'Arriving Soon',
    inTransitShipments: 'In Transit',
    cronJobStatus: 'Automated Tasks Status',
    runManualCheck: 'Manual Check',
    lastStatusCheck: 'Last Status Check',
    delayNotifications: 'Delay Notifications',
    automaticTracking: 'Automatic Tracking',
    
    // Flight API Integration
    flightApiStatus: 'Flight API',
    flightApiEnabled: 'API Enabled',
    flightApiDisabled: 'API Disabled',
    checkFlightStatus: 'Check Flight Status',
    flightNotFound: 'Flight Not Found',
    flightStatusUpdated: 'Flight Status Updated',
    realTimeTracking: 'Real-time Tracking',
    flightDetails: 'Flight Details',
    searchFlights: 'Search Flights',
    departureAirport: 'Departure Airport',
    arrivalAirport: 'Arrival Airport',
    aircraftType: 'Aircraft Type',
    gate: 'Gate',
    terminal: 'Terminal',
    delayMinutes: 'Delay (minutes)',
    
    // Company Settings
    companySettings: 'Company Settings',
    generalSettings: 'General Settings',
    transportSettings: 'Transport Settings',
    communicationSettings: 'Communication & Notifications',
    userAccessSettings: 'Users & Access',
    financialSettings: 'Financial Settings',
    enabledFeatures: 'Enabled Features',
    featureLockedByPlan: 'Some features require a higher plan',
    whatsapp_ai_responses: 'WhatsApp AI Responses',
    broadcast: 'Broadcast',

    // General Settings
    companyName: 'Company Name',
    companyType: 'Company Type',
    logoUrl: 'Logo URL',
    primaryColor: 'Primary Color',
    secondaryColor: 'Secondary Color',
    primaryCurrency: 'Primary Currency',
    timezone: 'Timezone',
    originCountry: 'Origin Country',
    servedCountries: 'Served Countries',
    warehouseAddresses: 'Warehouse Addresses',
    defaultLanguage: 'Default Language',
    
    // Company Types
    international_freight: 'International Freight',
    local_partner: 'Local Partner',
    transit_logistics: 'Transit Logistics',
    warehouse_operator: 'Warehouse Operator',
    customs_broker: 'Customs Broker',
    
    // Transport Settings
    mainAirline: 'Main Airline',
    freightTypes: 'Freight Types',
    defaultFreightType: 'Default Freight Type',
    averageBagWeight: 'Average Bag Weight (kg)',
    collectionMode: 'Collection Mode',
    travelFrequency: 'Travel Frequency',
    defaultArrivalAirports: 'Default Arrival Airports',
    averageCustomsTimeHours: 'Average Customs Time (hours)',
    flightApiEnabled: 'Flight API Enabled',
    trackingMode: 'Tracking Mode',
    trackingModeManual: 'Manual',
    trackingModeAutomatic: 'Automatic',
    trackingModeDescription: 'How your departure statuses are updated',
    trackingModeManualDesc: 'Manually change each departure status',
    trackingModeAutoDesc: 'Statuses updated via flight tracking API',
    trackingModeProRequired: 'Available with Pro or Enterprise plan',
    trackingModeBadgeManual: 'Manual tracking',
    trackingModeBadgeAuto: 'Auto tracking',
    statusChangeInline: 'Change status',

    // Freight Types
    express: 'Express',
    standard: 'Standard',
    economic: 'Economic',
    fragile: 'Fragile',
    
    // Collection Modes
    depot_only: 'Depot Only',
    home_collection: 'Home Collection',
    both: 'Both',
    
    // Travel Frequency
    weekly: 'Weekly',
    biweekly: 'Bi-weekly',
    monthly: 'Monthly',
    on_demand: 'On Demand',
    
    // Communication Settings
    senderEmail: 'Sender Email',
    senderName: 'Sender Name',
    whatsappNumber: 'WhatsApp Number',
    smsApiEnabled: 'SMS API Enabled',
    aiServiceEnabled: 'AI Service Enabled',
    cronFrequencyHours: 'Check Frequency (hours)',
    automationLevel: 'Automation Level',
    autoNotificationRules: 'Auto Notification Rules',
    
    // Automation Levels
    basic: 'Basic',
    medium: 'Medium',
    advanced: 'Advanced',
    
    // Financial Settings
    acceptedPaymentMethods: 'Accepted Payment Methods',
    billingCurrencies: 'Billing Currencies',
    pricingModel: 'Pricing Model',
    autoTaxReporting: 'Auto Tax Reporting',
    exchangeRateApiEnabled: 'Exchange Rate API Enabled',
    defaultMarginPercent: 'Default Margin (%)',
    
    // Payment Methods
    cash: 'Cash',
    card: 'Card',
    bank_transfer: 'Bank Transfer',
    mobile_money: 'Mobile Money',
    
    // Features
    qrCodeClient: 'QR Code Client',
    multiFreightTypes: 'Multiple Freight Types',
    multiCountry: 'Multi-Country',
    customBranding: 'Custom Branding',
    multiWarehouse: 'Multiple Warehouses',
    advancedAnalytics: 'Advanced Analytics',
    realtimeTracking: 'Real-time Tracking',
    
    // Statuts
    registered: 'Registered',
    pending_collection: 'Pending Collection',
    collected: 'Collected',
    verified: 'Verified',
    in_transit: 'In Transit',
    arrived: 'Arrived',
    customs_cleared: 'Customs Cleared',
    ready_for_pickup: 'Ready for Pickup',
    delivered: 'Delivered',
    
    // Shipment Statuses
    planned: 'Planned',
    scheduled: 'Scheduled',
    delayed: 'Delayed',
    completed: 'Completed',
    cancelled: 'Cancelled',
    
    // Paiement
    paid: 'Paid',
    unpaid: 'Unpaid',
    
    // Actions
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    validate: 'Validate',
    submit: 'Submit',
    search: 'Search',
    filter: 'Filter',
    
    // QR Code
    createQRCode: 'Create Client QR Code',
    qrCodeFor: 'QR Code for',
    scanQR: 'Scan this QR code',
    qrCodeSession: 'QR Code Session',
    qrExpires: 'Expires on',
    qrClientForm: 'QR Client Form',
    
    // Formulaires
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    country: 'Country',
    city: 'City',
    address: 'Address',
    required: 'Required',
    optional: 'Optional',
    
    // Messages & Notifications
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Information',
    loading: 'Loading...',
    noData: 'No data',
    filtered: 'filtered',
    searchPlaceholderGeneric: 'Search...',
    noResults: 'No results',
    edit: 'Edit',
    save: 'Save',
    delete: 'Delete',
    back: 'Back',
    close: 'Close',
    globalSearch: 'Global search',
    errorLoading: 'Error loading data',
    errorCreating: 'Error creating',
    errorUpdating: 'Error updating',
    errorStatusChange: 'Error changing status',
    errorCustomsClearance: 'Error clearing customs',
    errorAssigning: 'Error assigning',
    noShipmentsAvailable: 'No shipments available',
    noPendingPackages: 'No pending packages',
    noPackagesAvailable: 'No packages available to create a shipment',
    noRegisteredPackages: 'No registered packages',
    editShipment: 'Edit Shipment',
    sessionExpired: 'Session expired - Please reconnect',
    insufficientPermissions: 'Insufficient permissions',
    statusChanged: 'Status changed',
    currentStatus: 'Current status',
    searchByShipmentPlaceholder: 'Search by shipment, country, status, partner, OCE code...',
    searchByOcePlaceholder: 'Search by OCE code, sender name, recipient...',
    filterByPartner: 'Filter by partner',
    selectStatus: 'Select a status',
    statusChangeReason: 'Explain the reason for this status change...',
    customsDetailsPlaceholder: 'Customs clearance details...',
    groupCustomsPlaceholder: 'Group customs clearance details...',
    packageSearchTitle: 'Package Search',
    packageSearchDesc: 'Search for a package and find which shipment it belongs to',
    noPackagesFoundFor: 'No packages found for',
    noShipmentsInProgress: 'No shipments in progress',
    noCompletedShipments: 'No completed shipments',
    shipmentsInProgress: 'Shipments In Progress',
    completedShipments: 'Completed Shipments',
    allPartners: 'All partners',
    changeShipmentStatus: 'Change shipment status',
    changePackageStatus: 'Change package status',
    newStatus: 'New status',
    changeReason: 'Reason for change',
    modifying: 'Modifying...',
    confirm: 'Confirm',
    inProgress: 'In progress...',
    customsClearPackage: 'Clear customs for package',
    confirmCustomsClearance: 'Confirm customs clearance for package',
    noteOptional: 'Note (optional)',
    confirmCustoms: 'Confirm customs clearance',
    bulkCustomsClearance: 'Bulk customs clearance',
    clearNPackages: 'Clear {n} packages',
    clearNPackagesOf: 'Clear customs for {n} packages of shipment',
    minCharsSearch: 'Type at least 3 characters to search...',
    // Broadcast
    broadcast: 'Broadcast',
    broadcastSendNotif: 'Send a notification to senders and recipients of this shipment',
    broadcastSent: 'Broadcast sent',
    recipientsTargeted: 'recipient(s) targeted',
    showRecipients: 'Show recipients',
    hideRecipients: 'Hide recipients',
    loadingRecipients: 'Loading recipients...',
    sendingInProgress: 'Sending...',
    sent: 'Sent',
    failed: 'Failed',
    noRecipientsFound: 'No recipients found',
    subjectLabel: 'Subject',
    subjectPlaceholder: 'Notification subject',
    messageLabel: 'Message',
    messagePlaceholder: 'Your message...',
    broadcastChannels: 'Broadcast channels',
    subjectAndMessageRequired: 'Subject and message required',
    selectAtLeastOneChannel: 'Select at least one channel',
    errorSending: 'Error sending',
    recipients: 'recipient(s)',
    confirmDelete: 'Confirm deletion',
    deleteConfirmation: 'Are you sure you want to delete this item?',
    
    // Auth & Login
    loginTitle: 'Air Freight Management',
    loginSubtitle: 'Sign in to your account',
    loginButton: 'Sign in',
    loginLoading: 'Signing in...',
    register: 'Register',
    forgotPassword: 'Forgot Password',
    rememberMe: 'Remember Me',
    noAccount: 'No account?',
    emailPlaceholder: 'you@example.com',
    passwordPlaceholder: '••••••••',
    trackPackageLink: 'Track a package (OCE Code)',
    newCompany: 'New company?',
    createMyCompanyLink: 'Create my company',
    
    // Company & Organization
    company: 'Company',
    companyName: 'Company Name',
    createCompanyTitle: 'Create Company',
    partner: 'Partner',
    admin: 'Administrator',
    superAdmin: 'Super Administrator',
    countryAdmin: 'Country Administrator',
    localPartner: 'Local Partner',
    client: 'Client',
    
    // Dashboard & Navigation
    welcomeTo: 'Welcome to',
    overview: 'Overview',
    statistics: 'Statistics',
    recentActivity: 'Recent Activity',
    quickActions: 'Quick Actions',
    adminShipmentsView: 'Shipments View',
    myShipments: 'My Shipments',
    myPackages: 'My Packages',
    deliveries: 'Deliveries',
    
    // Common UI Elements
    close: 'Close',
    open: 'Open',
    expand: 'Expand',
    collapse: 'Collapse',
    refresh: 'Refresh',
    export: 'Export',
    import: 'Import',
    print: 'Print',
    download: 'Download',
    upload: 'Upload',
    
    // Time & Dates
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    thisYear: 'This Year',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    
    // General Terms
    total: 'Total',
    count: 'Count',
    active: 'Active',
    inactive: 'Inactive',
    enabled: 'Enabled',
    disabled: 'Disabled',
    available: 'Available',
    unavailable: 'Unavailable',

    // Audit & Security
    auditLog: 'Audit Log',
    auditLogs: 'Audit Logs',
    security: 'Security',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',

    // Users Management
    createUser: 'Create User',
    editUser: 'Edit User',
    deleteUser: 'Delete User',

    // Empty States & Misc
    noPackages: 'No packages',
    noShipments: 'No shipments',
    noUsers: 'No users',
    pageNotFound: 'Page Not Found',
    awaiting_customs: 'Awaiting Customs',

    // Pricing Section
    pricingTitle: 'Simple, Transparent Pricing',
    pricingSubtitle: 'Choose the plan that fits your business size. Switch plans anytime.',
    pricingMonthly: 'Monthly',
    pricingYearly: 'Yearly',
    pricingYearlySave: 'Save 20%',
    pricingFrom: 'Starting from',
    pricingPerMonth: '/month',
    pricingPerYear: '/year',
    pricingPopular: 'Popular',
    pricingCta: 'Choose this plan',
    pricingCtaEnterprise: 'Contact us',
    pricingCtaTrial: 'Start free trial',

    // Pricing - Starter
    pricingStarterName: 'Starter',
    pricingStarterDesc: 'Perfect to start your freight business',
    pricingStarterFeature1: 'Up to 100 packages/month',
    pricingStarterFeature2: '5 shipments/month',
    pricingStarterFeature3: '3 partners',
    pricingStarterFeature4: '5 users',
    pricingStarterFeature5: 'Email notifications',
    pricingStarterFeature6: 'Client QR Code',
    pricingStarterFeature7: 'Basic analytics',

    // Pricing - Pro
    pricingProName: 'Pro',
    pricingProDesc: 'For growing businesses',
    pricingProFeature1: 'Up to 500 packages/month',
    pricingProFeature2: '20 shipments/month',
    pricingProFeature3: '10 partners',
    pricingProFeature4: '20 users',
    pricingProFeature5: 'Everything in Starter +',
    pricingProFeature6: 'WhatsApp notifications',
    pricingProFeature7: 'Broadcast & Real-time notifications',
    pricingProFeature8: 'Advanced analytics',
    pricingProFeature9: 'Finance module',

    // Pricing - Enterprise
    pricingEnterpriseName: 'Enterprise',
    pricingEnterpriseDesc: 'For large-scale logistics operations',
    pricingEnterpriseFeature1: 'Unlimited packages',
    pricingEnterpriseFeature2: 'Unlimited shipments',
    pricingEnterpriseFeature3: 'Unlimited partners',
    pricingEnterpriseFeature4: 'Unlimited users',
    pricingEnterpriseFeature5: 'Everything in Pro +',
    pricingEnterpriseFeature6: 'Dedicated priority support',
    pricingEnterpriseFeature7: 'Custom integrations',
    pricingEnterpriseFeature8: 'Guaranteed SLA',
    pricingEnterpriseFeature9: 'Dedicated account manager',

    // Business Stats (landing page)
    statCompanies: 'Active companies',
    statPackages: 'Packages tracked',
    statCountries: 'Countries covered',
    statUptime: 'Uptime',

    // Improved CTA
    ctaStartTrial: 'Start free trial',
    ctaTrialSubtext: '14 days free, no credit card required',

    // Nav anchors
    navFeatures: 'Features',
    navPricing: 'Pricing',
    navTestimonials: 'Testimonials',
    navSectionLabel: 'Freight management',
    navBenefits: 'Benefits',
    navSolutions: 'Platform',
    navDemo: 'Demo',
    navTrust: 'Operations',
    navRequestDemo: 'Request a demo',
    breadcrumbHome: 'Home',
    breadcrumbLabel: 'Breadcrumb',

    // Footer enriched
    footerProduct: 'Product',
    footerCompany: 'Company',
    footerSupport: 'Support',
    footerLegal: 'Legal',
    footerAbout: 'About',
    footerBlog: 'Blog',
    footerCareers: 'Careers',
    footerContact: 'Contact',
    footerHelpCenter: 'Help Center',
    footerDocumentation: 'Documentation',
    footerApiReference: 'API Reference',
    footerStatusPage: 'Status Page',
    footerPrivacy: 'Privacy',
    footerTerms: 'Terms of Service',
    footerCookies: 'Cookies',

    // Plan & Billing
    subscription: 'Subscription',
    planAndBilling: 'Plan & Billing',
    planAndBillingSubtitle: 'Manage your subscription, track usage and limits',
    subscriptionManagement: 'Subscription Management',
    currentPlan: 'Current Plan',
    changePlan: 'Change Plan',
    upgradePlan: 'Upgrade',
    manageBilling: 'Manage Billing',
    renewalDate: 'Renewal Date',
    renewsOn: 'Renews on',
    usage: 'Usage',
    usageThisMonth: 'Usage this month',
    allSubscriptions: 'All Subscriptions',
    overridePlan: 'Override Plan',
    monthlyRevenue: 'Monthly Recurring Revenue',
    planMenu: 'Plan & Billing',
    usersCount: 'Users',
    packagesMonth: 'Packages this month',
    shipmentsMonth: 'Shipments this month',
    broadcastsSent: 'Messages sent',
    partnersCount: 'Partners',
    totalPackages: 'Total packages',
    unlimited: 'Unlimited',
    ofLimit: 'of',
    planFeatures: 'Included features',
    planLimits: 'Plan limits',
    perMonth: '/mo',
    perYear: '/yr',
    activeUsers: 'active users',
    thisMonth: 'this month',
    totalSent: 'total sent',
    noSubscription: 'No active subscription',
    noSubscriptionDesc: 'Choose a plan to unlock all features',
    comparePlans: 'Compare plans',
    featureEmail: 'Email notifications',
    featureQr: 'QR Code',
    featureBasicAnalytics: 'Basic analytics',
    featureAdvancedAnalytics: 'Advanced analytics',
    featureWhatsapp: 'WhatsApp notifications',
    featureBroadcast: 'Message broadcast',
    featureFinance: 'Finance module',
    featureWhatsappAi: 'WhatsApp AI responses',

    // Shared Auth
    passwordsMismatch: 'Passwords do not match',
    passwordMinLength: 'Password must be at least 6 characters',
    home: 'Home',
    alreadyHaveAccount: 'Already have an account?',
    signIn: 'Sign in',
    or: 'or',
    back: 'Back',
    creating: 'Creating...',
    continue: 'Continue',

    // Package creation flow (package-form)
    packageStep_route: 'Route',
    packageStep_contacts: 'Contacts',
    packageStep_items: 'Packages',
    packageStep_payment: 'Payment',

    // Login page extras
    passwordResetSuccess: 'Password reset successfully! You can now sign in.',
    loginHeroTitle: 'Simplify your freight management',
    loginAIDesc: 'Track your shipments, manage your partners and optimize your logistics operations from a single platform.',
    loginFeatureTracking: 'Real-time tracking',
    loginFeatureMultiCountry: 'Multi-country management',
    loginFeatureNotifications: 'Automatic notifications',

    // Register page
    registrationSuccess: 'Your account has been submitted for approval',
    redirectingToLogin: 'Redirecting to login page...',
    createAccount: 'Create an account',
    registerSubtitle: 'Sign up to track your packages',
    fullName: 'Full name',
    yourName: 'Your name',
    registering: 'Registering...',
    signUp: 'Sign up',

    // Forgot password page
    forgotPasswordTitle: 'Forgot your password?',
    forgotPasswordDesc: 'Enter your email to receive a reset link',
    resetMyPassword: 'Reset my password',
    resetEmailDesc: 'A password reset link will be sent to this address',
    emailAddress: 'Email address',
    emailPlaceholderForgot: 'your.email@example.com',
    sendingEmail: 'Sending...',
    sendResetLink: 'Send reset link',
    backToLogin: 'Back to login',
    checkSpamTip: 'Also check your spam folder if you don\'t receive the email.',

    // Reset password page
    resetTokenMissing: 'Reset token is missing or invalid',
    invalidResetLink: 'Invalid or expired reset link.',
    requestNewLink: 'Request a new link',
    newPasswordTitle: 'New password',
    newPasswordDesc: 'Set your new secure password',
    resetPasswordCardTitle: 'Reset password',
    chooseStrongPassword: 'Choose a strong password with at least 6 characters',
    enterNewPassword: 'Enter your new password',
    confirmYourPassword: 'Confirm your new password',
    passwordTooShort: 'Password must be at least 6 characters',
    passwordsDontMatch: 'Passwords do not match',
    resetting: 'Resetting...',
    setNewPassword: 'Set new password',

    // CreateCompany page
    createYourCompany: 'Create Your Company',
    stepXofY: 'Step {step} of {total}',
    companyInfoStep: 'Company information',
    superAdminStep: 'Super administrator creation',
    companyCreatedSuccess: 'Company created successfully!',
    createCompanyError: 'Error creating company',
    superAdminCreatedSuccess: 'Super administrator created successfully! You can now sign in.',
    createSuperAdminError: 'Error creating super administrator',
    companyInfoTitle: 'Company Information',
    companyInfoDesc: 'Enter your transport company information',
    companyNameRequired: 'Company name *',
    companyCodeRequired: 'Company code *',
    countryRequired: 'Country *',
    selectCountry: 'Select a country',
    contactEmailRequired: 'Contact email *',
    phoneOptional: 'Phone',
    descriptionOptional: 'Description',
    descriptionPlaceholder: 'Describe your transport company...',
    createCompanyButton: 'Create company',
    superAdminTitle: 'Super Administrator Creation',
    superAdminDesc: 'Create the main admin account for your company',
    fullNameRequired: 'Full name *',
    emailRequired: 'Email *',
    passwordRequired: 'Password *',
    passwordMin6: 'Minimum 6 characters',
    confirmPasswordRequired: 'Confirm password *',
    confirmPasswordPlaceholder: 'Confirm password',

    // RegisterCompany page
    joinFretManager: 'Join FretManager',
    createYourSpace: 'Create your space in 3 steps and start managing your shipments',
    freeRegistration: 'Free registration',
    multiCountryFromStart: 'Multi-country from the start',
    operationalIn5Min: 'Operational in 5 minutes',
    createYourCompanyTitle: 'Create your company',
    stepXofTotal: 'Step {step} of 3',
    accountInfo: 'Account information',
    companyInfo: 'Company information',
    freightType: 'Freight type *',
    airFreight: 'Air Freight',
    maritimeFreight: 'Maritime Freight',
    airAndMaritimeFreight: 'Air + Maritime Freight',
    shippingCountry: 'Shipping country (HQ) *',
    selectACountry: 'Select a country',
    defaultDeliveryZone: 'Default delivery zone',
    deliveryCountry: 'Delivery country *',
    deliveryCities: 'Delivery cities *',
    add: 'Add',
    selectCity: 'Select a city',
    canAddMoreLater: 'You can add more cities and detailed addresses after registration',
    previous: 'Previous',
    next: 'Next',
    creatingCompany: 'Creating...',
    createMyCompany: 'Create my company',
    registrationError: 'Error during registration',
    redirectingToSignIn: 'Your account is awaiting approval by our team. You will receive an email once it is activated.',

    // ProfessionalLayout sidebar
    overviewMenu: 'Overview',
    operationsSection: 'OPERATIONS',
    myPackagesMenu: 'My Packages',
    allPackages: 'All packages',
    drafts: 'Drafts',
    departuresMenu: 'Shipments',
    deliveriesMenu: 'Deliveries',
    analysisSection: 'ANALYSIS',
    statisticsMenu: 'Statistics',
    financeMenu: 'Finance',
    managementSection: 'MANAGEMENT',
    broadcastMenu: 'Broadcast',
    teamMenu: 'Users',
    auditLogMenu: 'Audit Log',
    settingsMenu: 'Settings',
    usersMenu: 'Users',
    companyMenu: 'Company',
    subscriptionsMenu: 'Subscriptions',
    adminMenu: 'Platform Admin',
    monitoringMenu: 'Monitoring',

    // ForcePasswordChange
    passwordChangeRequired: 'Password change required',
    passwordChangeDesc: 'For your security, you must set a new password',
    accountSecurity: 'Account security',
    yourEmail: 'Your email',
    chooseNewPassword: 'Choose a new secure password',
    confirmNewPasswordPlaceholder: 'Confirm your password',
    changePasswordButton: 'Change password',
    changingPassword: 'Changing password...',
    passwordChangeError: 'Error changing password',
    loginError: 'Login error. Please try again.',

    // OnlineUsers
    offline: 'Offline',
    online: 'Online',
    viewingDashboard: 'Viewing dashboard',
    viewingPackages: 'Viewing packages',
    viewingShipments: 'Viewing shipments',
    viewingAnalytics: 'Viewing analytics',
    viewingSettings: 'Viewing settings',
    editingPackage: 'Editing a package',
    editingShipment: 'Editing a shipment',
    creatingPackage: 'Creating a package',
    creatingShipment: 'Creating a shipment',
    justNow: 'Just now',
    companyAdminRole: 'Company Admin',
    countryAdminRole: 'Country Admin',
    partnerRole: 'Partner',
    onlineUsersTitle: 'Online users',
    connectedUsers: 'connected',

    // ShipmentMonitoring
    monitoringLoadError: 'Error loading monitoring data',
    manualCheckError: 'Error during manual check',

    // CookieConsent
    dataProtection: 'Data Protection',
    cookieMessage: 'FretManager uses cookies for the proper functioning of the site and to improve your experience.',
    cookieContinue: 'By continuing, you accept our',
    cookiePrivacyPolicy: 'privacy policy',
    cookieAccept: 'Accept',
    cookieAcceptAll: 'Accept all',
    cookieRefuse: 'Refuse',
    cookieManagePrefs: 'Manage preferences',
    cookieSavePrefs: 'Save',
    cookieEssential: 'Essential',
    cookieEssentialDesc: 'Required for the site to function (authentication, security). Always active.',
    cookieAnalytics: 'Analytics',
    cookieAnalyticsDesc: 'Help us understand how you use the site to improve it.',
    cookieFunctional: 'Functional',
    cookieFunctionalDesc: 'Remember your preferences (theme, language) to personalize your experience.',

    // ConfirmDialog
    confirmation: 'Confirmation',
    actionIrreversible: 'This action is irreversible.',
    confirm: 'Confirm',

    // NotificationBell
    noNotifications: 'No notifications',
    notifications: 'Notifications',

    // PackagePhotosDialog
    noPhotos: 'No photos for this package',

    // TrackPackage
    trackYourPackage: 'Track your package',
    packageNotFound: 'Package not found. Check the OCE code.',

    // ClientDashboard
    enterOceToTrack: 'Enter your OCE code to track the status of your shipment',
    enterOcePlaceholder: 'Enter the OCE code (e.g. OCE12345678)',
    searching: 'Searching...',
    trackBtn: 'Track',
    packageDetails: 'Package details',
    trackingHistory: 'Tracking history',
    aboutOceCode: 'About the OCE code',
    oceCodeDescription: 'The OCE code is provided when your package is registered. Keep it safe to track your shipment at any time.',

    // SuperAdminDashboard
    companyManagement: 'Company Management',
    loadingData: 'Loading...',
    unableToLoadData: 'Unable to load management data',
    errorLoadingData: 'Error loading management data',
    searchPackage: 'Search Package',
    pendingPackages: 'Pending Packages',
    unassigned: 'Unassigned',
    partnersInvolved: 'Partners Involved',
    withPendingPackages: 'With pending packages',
    topDestinations: 'Top Destinations',
    destinationCountries: 'Destination countries',
    recommendation: 'Recommendation',
    urgent: 'URGENT',
    moderate: 'MODERATE',
    wait: 'WAIT',
    shipmentMonitoring: 'Shipment Monitoring',
    flightApi: 'Flight API',
    usersTab: 'Users',
    emailsTab: 'Emails',
    companySettings: 'Company Settings',
    geographicManagement: 'Geographic Management',
    userManagement: 'User Management',
    addUser: 'Add user',
    suspended: 'Suspended',
    suspendUser: 'Suspend',
    suspensionReason: 'Suspension reason',
    explainReason: 'Explain the reason...',
    durationDays: 'Duration (days, empty = permanent)',
    cancel: 'Cancel',
    addUserTitle: 'Add User',
    autoPassword: 'A temporary password will be automatically generated and sent by email. The user will need to change it on first login.',
    autoPasswordLabel: 'Automatic password:',
    name: 'Name',
    email: 'Email',
    role: 'Role',
    phone: 'Phone',
    country: 'Country',
    city: 'City',
    useCompanyCountry: 'Use company country',
    notDefined: 'Not defined',
    selectCity: 'Select a city (optional)',
    unknownCity: 'Unknown city',
    unknownCountry: 'Unknown country',
    geoAssignment: 'Geographic Assignment',
    assignedZone: 'Assigned geographic zone',
    selectZone: 'Select a zone...',
    selectedZone: 'Selected zone:',
    countriesLabel: 'Countries',
    citiesLabel: 'Cities',
    allCities: 'All cities',
    none: 'None',
    userCreatedSuccess: 'User created successfully',
    tempPasswordGenerated: 'Temporary password generated.',
    credentialsSent: 'An email with login credentials has been sent to the user.',
    invitationSent: 'An invitation email was sent: the partner will set their password via the received link.',
    invitationNotSentUseLink: 'The email could not be sent. Share this activation link with the partner:',
    copy: 'Copy',
    pendingActivation: 'Pending activation',
    resendInvitation: 'Resend invitation',
    invitationResent: 'Invitation resent by email',
    createUser: 'Create user',
    emailNotifications: 'Email Notifications Management',
    testEmail: 'Test Email',
    emailServiceStatus: 'Email Service Status',
    service: 'Service',
    state: 'State',
    enabled: 'Enabled',
    disabled: 'Disabled',
    senderLabel: 'Sender',
    emailNotConfigured: 'Email service is not configured. Add a SendGrid API key in environment variables to enable automatic email notifications.',
    emailNotifTypes: 'Email Notification Types',
    emailNotifDesc: 'Emails are automatically sent for the following events',
    emailOnCreation: 'Package creation (if sender email provided)',
    emailOnCollected: 'Status change: Collected',
    emailOnTransit: 'Status change: In transit',
    emailOnArrived: 'Status change: Arrived at destination',
    emailOnReady: 'Status change: Ready for pickup',
    emailOnDelivered: 'Status change: Delivered',
    testEmailTitle: 'Test Email Sending',
    recipientEmail: 'Recipient Email',
    subject: 'Subject',
    message: 'Message',
    sending: 'Sending...',
    send: 'Send',
    testEmailSuccess: 'Test email sent successfully!',
    errorSendingEmail: 'Error sending test email',
    errorSuspending: 'Error suspending user',
    errorUnsuspending: 'Error reactivating user',
    errorAddingUser: 'Error adding user',
    userSuspended: 'suspended successfully',
    userReactivated: 'reactivated successfully',
    createdOn: 'Created on',
    active: 'Active',
    inactive: 'Inactive',
    collectPartner: 'Collection Partner',
    deliveryPartner: 'Delivery Partner',
    countryAdminRole: 'Country Admin',
    companyAdminRole: 'Company Admin',

    // NotFound
    notFoundDesc: 'The page you are looking for does not exist or has been moved.',

    // Dashboard
    roleNotRecognized: 'User role not recognized',

    // SettingsPage tabs
    profileTab: 'Profile',
    languageTab: 'Language',
    notificationsTab: 'Notifications',
    securityTab: 'Security',
    companyTab: 'Company',
    billingTab: 'Billing',

    // QRClientForm
    qrSessionNotFound: 'QR session not found or invalid',
    qrSessionExpired: 'QR session expired or already used',
    qrLoadError: 'Error loading session',

    // Navbar landing
    trackAPackage: 'Track a package',
    multiCountry: 'Multi-country',
    help: 'Help',
    freeTrial: 'Free trial',

    // Hero landing
    heroTitle: 'Manage your international freight simply',
    heroSubtitle: 'Real-time tracking, automatic notifications, multi-country management. A single platform to manage your shipments end to end.',

    // Transport mode
    transportMode: 'Transport mode',
    air: 'Air',
    maritime: 'Maritime',

    // Contact modal / page
    contactUs: 'Contact us',
    ourTeamIsHere: 'Our team is here to help',
    sendUsMessage: 'Send us a message',
    messageSent: 'Message sent!',
    willReplyIn24h: 'We\'ll get back to you within 24h.',
    fullNamePlaceholder: 'Full name *',
    companyPlaceholder: 'Company *',
    phonePlaceholder: 'Phone',
    yourMessage: 'Your message...',
    sending: 'Sending...',
    send: 'Send',
    backToHome: 'Back to home',
    passwordRule: 'At least 8 characters, one letter and one digit.',
    hours: 'Hours',
    hoursValue: 'Mon-Fri, 9am-6pm CET',
    addressLabel: 'Address',

    // Privacy, Terms, Help - shared
    lastUpdated: 'Last updated: May 25, 2026',

    // Misc
    allRightsReserved: 'All rights reserved.',
    tip: 'Tip',

    // ForcePasswordChange extras
    temporaryPasswordMsg: 'Your account uses a temporary password. Please set a personal secure password.',
    actionRequired: 'Action required:',
    actionRequiredMsg: 'You must change your password to continue using FretManager.',
    newPasswordLabel: 'New password',
    newPasswordPlaceholder: 'Enter your new password',
    confirmNewPasswordLabel: 'Confirm new password',
    confirmNewPasswordPlaceholder2: 'Confirm your new password',
    passwordValid: 'Valid password',
    setNewPasswordButton: 'Set my new password',
    passwordTipsTitle: 'Tips for a secure password:',
    passwordTip1: 'At least 6 characters',
    passwordTip2: 'Mix letters, numbers and symbols',
    passwordTip3: 'Avoid dictionary words',
    passwordTip4: 'Don\'t use personal information',

    // OnlineUsers extras
    noOtherUsersOnline: 'No other users online',
    connectedSince: 'Connected',
    viewingPage: 'Viewing a page',
    viewingResource: 'Viewing',
    editingResource: 'Editing',
    editingData: 'Editing data',
    creatingResource: 'Creating a',
    creatingContent: 'Creating content',

    // ShipmentMonitoring extras
    loadingMonitoring: 'Loading monitoring data...',
    expectedArrival: 'Expected arrival',
    noTransitShipments: 'No shipments currently in transit',
    flightCheckError: 'Error during real-time flight check',
    cronActive: 'Active',
    cronStopped: 'Stopped',
    notDefined: 'Not defined',
    manualCheckRunError: 'Error running manual check',
    flightApiError: 'Flight API error',
    serviceUnavailable: 'Service unavailable',

    // PackageSearch extras
    searchPackage: 'Search Package',
    searchPlaceholder: 'OCE code, sender/recipient name, email...',
    allFields: 'All fields',
    oceCodeField: 'OCE Code',
    senderField: 'Sender',
    recipientField: 'Recipient',
    searchButton: 'Search',
    statusLabel: 'Status',
    allStatuses: 'All statuses',
    startDate: 'Start date',
    endDate: 'End date',
    noPackageFound: 'No package found for',
    tryOtherSearch: 'Try a different search term',
    resultsFound: 'result(s) found',
    enterSearchTerm: 'Enter a search term or use the filters',
    minCharsSearch: 'Minimum 2 characters for text search',
    weightLabel: 'Weight',
    createdLabel: 'Created',
    shipmentDeparture: 'Shipment',
    collectedBy: 'Collected by',

    // PackagePhotosDialog extras
    photos: 'Photos',

    // CookieConsent extras
    cookieLearnMore: 'Learn more',
    closeCookie: 'Close',

    // Footer extras
    footerBrandDesc: 'International freight management platform. Tracking, notifications, multi-actor collaboration.',

    // SettingsPage - Profile section
    personalInfo: 'Personal information',
    role: 'Role',
    assignedCountry: 'Assigned country',

    // SettingsPage - Language section
    interfaceLanguageDesc: 'Interface display language',
    interfaceLanguage: 'Interface language',
    languageSavedAutomatically: 'Language will be saved automatically and applied to all pages.',

    // SettingsPage - Notifications section
    receiveNotifByEmail: 'Receive notifications by email',
    receiveNotifByWhatsApp: 'Receive notifications by WhatsApp',
    preferredNotifChannel: 'Preferred notification channel',

    // SettingsPage - Security section
    passwordChangedSuccess: 'Password changed successfully',

    // SettingsPage - Company section
    companyGeneralConfig: 'General company configuration',
    manageCompanyDesc: 'Manage your company settings: countries, currencies, transport, partners.',
    manageCompany: 'Manage company',

    // SettingsPage - Billing section
    billingDesc: 'Numbering, exchange rates, template and invoice images',
    invoiceTemplate: 'Invoice template',
    invoiceTemplateDesc: 'Design and colors of your invoices',
    templateClassic: 'Classic',
    templateClassicDesc: 'Standard professional design',
    templateModern: 'Modern',
    templateModernDesc: 'Thick bar, rounded cards',
    templateMinimal: 'Minimal',
    templateMinimalDesc: 'Sober, thin borders, white background',
    templateBold: 'Bold',
    templateBoldDesc: 'Full color header, large text',
    saving: 'Saving...',
    preview: 'Preview',
    invoicePreview: 'Invoice preview',
    settingsSaved: 'Settings saved',
    saveError: 'Error saving settings',
    signatureUploaded: 'Signature uploaded',
    stampUploaded: 'Stamp uploaded',
    uploadError: 'Upload error',
    previewLoadError: 'Error loading preview',
    numbering: 'Numbering',
    numberingDesc: 'Prefix and default client',
    invoicePrefix: 'Numbering prefix',
    invoicePrefixExample: 'Example: FAC-2026-0001',
    defaultClient: 'Default client',
    defaultClientDesc: 'Who the invoice is addressed to by default',
    exchangeRates: 'Exchange rates',
    exchangeRatesDesc: 'EUR conversion to other currencies',
    leaveEmptyNoConversion: 'Leave empty to not display the conversion',
    signatureAndStamp: 'Signature & Stamp',
    signatureAndStampDesc: 'Images displayed on invoices',
    signatureLabel: 'Signature (PNG/JPG)',
    stampLabel: 'Stamp (optional)',
    currencyXAF: 'CFA Franc (XAF)',
    currencyUSD: 'US Dollar (USD)',
    currencyGBP: 'British Pound (GBP)',
    currencyCAD: 'Canadian Dollar (CAD)',
    companyLogo: 'Company Logo',
    companyLogoDesc: 'Appears on invoices and emails sent to customers',
    noLogo: 'No logo configured',
    logoUploadHint: 'PNG, JPG, WebP or SVG — max 2 MB',
    logoUploadSuccess: 'Logo updated',
    logoDeleted: 'Logo deleted',

    // SettingsPage - Layout
    managePreferences: 'Manage your preferences and configurations',
    preferenceSaved: 'Preference saved successfully!',
    preferenceUpdateError: 'Error updating preference',
    personal: 'Personal',
    administration: 'Administration',

    // QRClientForm extras
    qrSubmitError: 'Error submitting form',
    invalidSession: 'Invalid Session',
    infoSent: 'Information Sent',
    infoTransmittedTo: 'Your information has been transmitted to',
    willVerifyAndCreate: 'They will verify and create your package.',
    willReceiveConfirmation: 'You will receive a confirmation email with the tracking code once the package is created.',
    shipAPackage: 'Ship a Package',
    with: 'With',
    sessionExpiresOn: 'Session expires on',
    packageInfoTitle: 'Your Package Information',
    packageInfoDesc: 'Fill in all fields to create your package. You will receive a confirmation email.',
    yourInfoSender: 'Your Information (Sender)',
    trackingNotifToThisEmail: 'You will receive tracking notifications at this address',
    recipientInfo: 'Recipient Information',
    recipientEmail: 'Recipient email',
    merchandiseType: 'Merchandise type',
    noCategory: 'No category',
    advance: 'Advance',
    advanceAmount: 'Advance amount',
    contentDescription: 'Content description',
    describeContentForCustoms: 'Describe the content precisely to avoid customs issues',
    sendInfo: 'Send Information',
    submitDisclaimer: 'By clicking, you agree that your information will be transmitted to the carrier',

    // TermsOfService
    termsOfService: 'Terms of Service',
    tosPurpose: '1. Purpose',
    tosServiceDescription: '2. Service Description',
    tosRegistration: '3. Registration & Account',
    tosProhibitedUses: '4. Prohibited Uses',
    tosLiability: '5. Liability',
    tosSubscriptions: '6. Subscriptions & Termination',
    tosContact: '7. Contact',
    legalDepartment: 'Legal Department',

    // HelpCenter
    helpCenter: 'Help Center',
    findAnswers: 'Find answers to your questions',
    helpPackageManagement: 'Package Management',
    helpShipments: 'Shipments & Departures',
    helpRolesUsers: 'Roles & Users',
    helpBilling: 'Billing & Payments',
    helpConfiguration: 'Settings',
    helpNeedMore: 'Need more help?',
    contactSupport: 'Contact our support',
    responseTime24h: 'Response time: within 24h on business days',

    // PrivacyPolicy
    privacyPolicy: 'Privacy Policy',
    privacyDataCollected: '1. Data We Collect',
    privacyDataUsage: '2. How We Use Your Data',
    privacyDataProtection: '3. Data Protection',
    privacyDataSharing: '4. Data Sharing',
    privacyDataRetention: '5. Data Retention',
    privacyYourRights: '6. Your Rights',
    privacyContact: '7. Contact',
    responseTime30d: 'Response time: 30 days maximum',

    // CompanySettingsManager
    settingsLoadError: 'Error loading settings',
    connectionErrorLoading: 'Connection error while loading',
    settingsUpdatedSuccess: 'Settings updated successfully',
    settingsUpdateError: 'Error updating settings',
    connectionErrorUpdating: 'Connection error while updating',
    loadingSettings: 'Loading settings...',
    cannotLoadCompanySettings: 'Unable to load company settings.',
    companyNamePlaceholder: 'Your company name',
    chooseCompanyType: 'Choose company type',
    transportModes: 'Transport modes',
    selectTransportModes: 'Select the transport modes offered by your company',
    seaFreight: 'Sea Freight',
    airFreightShort: 'Air',
    seaFreightShort: 'Sea',
    defaultMode: 'Default mode',
    broadcastChannels: 'Broadcast channels',
    selectBroadcastChannels: 'Select channels used for broadcasts to customers',
    inAppNotification: 'In-App Notification',
    yourCompanyPlaceholder: 'Your Company',
    currencyEur: 'EUR - Euro',
    currencyUsd: 'USD - Dollar',
    currencyXaf: 'XAF - CFA Franc',
    currencyGbp: 'GBP - British Pound',
    currencyCad: 'CAD - Canadian Dollar',

    // GeographicSelector
    originCountryLabel: 'Origin country',
    destinationCountryLabel: 'Destination country',
    loadingCountries: 'Loading countries...',
    days: 'days',
    cities: 'cities',
    originCityLabel: 'Origin city',
    destinationCityLabel: 'Destination city',
    selectCityOptional: 'Select a city (optional)',
    deliveryIn: 'Delivery in',
    daysTo: 'day(s) to',

    // GeographicManagement
    addDeliveryCountry: 'Add a Delivery Country',
    countryNamePlaceholder: 'Country name (e.g. Cameroon)',
    countryCodePlaceholder: 'Country code (e.g. CM)',
    deliveryTimePlaceholder: 'Delivery time (days)',
    addCountryBtn: 'Add Country',
    addCity: 'Add a City',
    cityNamePlaceholder: 'City name',
    cityCodePlaceholder: 'City code (e.g. YAO)',
    addCityBtn: 'Add City',
    configuredDeliveryCountries: 'Configured Delivery Countries',
    customCountries: 'Custom Countries',
    customCountriesDescription: 'Add additional countries and cities that will appear in creation forms.',
    customCountryNamePlaceholder: 'Country name (e.g. Togo)',
    customCitiesPlaceholder: 'Cities separated by comma (e.g. Lomé, Kara)',
    noCustomCountries: 'No custom countries added.',
    createGeographicZone: 'Create a Geographic Zone',
    zoneNamePlaceholder: 'Zone name (e.g. Cameroon - Central)',
    countryWideZone: 'Country-wide zone',
    createZoneBtn: 'Create Zone',
    configuredZones: 'Configured Zones',
    wholeCountry: 'Whole country',
    citiesLabel: 'Cities',
    localPartnersAssignments: 'Local Partners and their Assignments',
    zoneLabel: 'Zone',
    countryLabel: 'Country',
    notAssigned: 'Not assigned',
    none: 'None',
    noneF: 'None',
    editAssignment: 'Edit assignment',
    assignToZone: 'Assign to a zone...',
    wholeCountryOption: 'Whole country...',
    loadingGeographicData: 'Loading geographic data...',
    geographicManagement: 'Geographic Management',
    countriesAndCities: 'Countries & Cities',
    geographicZones: 'Geographic Zones',
    localPartners: 'Local Partners',

    // MerchandiseCategoryManager
    cannotLoadCategories: 'Unable to load categories.',
    categoriesSaved: 'Categories saved.',
    merchandiseCategories: 'Merchandise categories (fixed surcharge)',
    noCategoriesConfigured: 'No categories configured. Click "Add" to get started.',
    fixedPrice: 'Fixed price',
    currency: 'Currency',
    categoryNamePlaceholder: 'E.g. Phone, Electronics...',
    savingInProgress: 'Saving...',
    saveBtn: 'Save',

    // RoutePricingGrid
    cannotLoadSettings: 'Unable to load settings.',
    pricingSaved: 'Pricing saved.',
    routePricing: 'Route pricing (price/kg)',
    noRoutesConfigured: 'No routes configured. Click "Add" to get started.',
    origin: 'Origin',
    destination: 'Destination',
    pricePerKg: 'Price/kg',

    // FinancePage
    financeLoadError: 'Unable to load financial data.',
    financeSaveSuccess: 'Financial data saved.',
    financeDetail: 'Financial detail',
    shipment: 'Shipment',
    route: 'Route',
    totalWeight: 'Total weight',
    financeSummary: 'Financial summary',
    totalRevenue: 'Total revenue',
    collectedRevenue: 'Collected revenue',
    debtUnpaid: 'Debt (unpaid)',
    totalCharges: 'Total charges',
    profit: 'Profit',
    relatedPackages: 'Related packages',
    oceCode: 'OCE Code',
    price: 'Price',
    payment: 'Payment',
    chargesDetail: 'Charges detail',
    notes: 'Notes',
    optionalRemarks: 'Optional remarks...',
    settingsUpdated: 'Settings updated.',
    defaultChargesSettings: 'Default charges settings',
    saveDefaults: 'Save defaults',
    shipmentsLoadError: 'Unable to load shipments.',
    noShipmentsDescription: 'Financial data will appear here once the first shipments are created',
    searchShipmentRoute: 'Search shipment, route...',
    revenue: 'Revenue',
    charges: 'Charges',
    marginPercent: 'Margin %',
    profitable: 'Profitable',
    unprofitable: 'Unprofitable',
    details: 'Details',
    annualView: 'Annual view',
    annualDataLoadError: 'Unable to load annual data.',
    searchMonth: 'Search a month...',
    month: 'Month',
    annualTotals: 'Annual totals',
    totalProfit: 'Total profit',
    totalDebt: 'Total debt',
    shipmentsCount: 'Shipments count',
    profitableOnes: 'Profitable',
    paymentRecorded: 'Payment recorded',
    paymentError: 'Payment error',
    sentVia: 'Sent via',
    sendFailed: 'Send failed',
    sendError: 'Send error',
    pdfDownloadError: 'PDF download error',
    all: 'All',
    pending: 'Pending',
    settled: 'Settled',
    searchInvoiceClient: 'Search invoice, client, OCE code...',
    noInvoiceFound: 'No invoice found',
    invoiceNumber: 'No.',
    packageStatus: 'Package status',
    package: 'Package',
    remaining: 'Remaining',
    detail: 'Detail',
    invoice: 'Invoice',
    associatedShipment: 'Associated shipment',
    type: 'Type',
    paymentHistory: 'Payment history',
    addPayment: 'Add a payment',
    amount: 'Amount',
    noteOptional: 'Note (optional)',
    recording: 'Recording...',
    recordPayment: 'Record payment',
    downloadPdf: 'Download PDF',
    sendToClient: 'Send to client',
    netProfit: 'Net profit',
    debt: 'Debt',
    finance: 'Finance',
    financeSubtitle: 'Is it profitable for us?',
    byShipment: 'By Shipment',
    invoices: 'Invoices',
    pricing: 'Pricing',
    analysis: 'Analysis',

    // Invoice tab rework
    issuedThisMonth: 'Issued this month',
    collectedAmount: 'Collected',
    pendingAmount: 'Pending',
    overdueAmount: 'Overdue',
    avgPaymentDelay: 'Avg payment delay',
    daysUnit: 'days',
    debtAgingTitle: 'Debt aging',
    lessThan30d: '< 30d',
    between30and60d: '30-60d',
    between60and90d: '60-90d',
    moreThan90d: '> 90d',
    issuedOn: 'Issued on',
    dueDate: 'Due date',
    paymentProgress: 'Payment',
    overdueStatus: 'Overdue',
    paidStatus: 'Paid',
    draftStatus: 'Draft',
    publicLink: 'Public link',
    reminderBtn: 'Remind',
    invoiceSummary: 'Invoice summary',
    billedTo: 'Billed to',
    unitPriceHT: 'Unit price',
    quantity: 'QTY',
    totalHT: 'Total',
    designation: 'Description',
    subtotal: 'Subtotal',
    paidAmount: 'Paid',
    remainingDue: 'Remaining due',
    paymentOf: 'Payment of',
    linkedShipment: 'Linked shipment',
    profitability: 'Profitability',
    margin: 'Margin',
    invoiceActions: 'Actions',
    noPaymentsYet: 'No payments recorded',
    overdueFilter: 'Overdue',
    allInvoices: 'All',
    paidFilter: 'Paid',
    pendingFilter: 'Pending',
    invoiceCount: 'invoices',
    weightLabel: 'Weight',

    // CountryAdminDashboard
    countryAdminDashboard: 'Dashboard - Country Admin',
    totalPackages: 'Total Packages',
    partners: 'Partners',
    inTransit: 'In Transit',
    recentPackages: 'Recent packages',
    manageCountryPackages: 'Manage all packages in your country',

    // UnifiedDashboard
    minutesAgo: '{n}min ago',
    hoursAgo: '{n}h ago',
    daysAgo: '{n}d ago',
    activityNew: 'New',
    activityUpdated: 'Updated',
    activityShipment: 'Shipment',
    activityPhoto: 'Photo',
    activityUser: 'User',
    activityAction: 'Action',
    deliveredPackages: 'Delivered packages',
    overdueInvoices7d: 'Unpaid invoices 7d+',
    awaitingCustomsClearance: 'Awaiting customs clearance',
    reportedIncidents: 'Reported incidents',
    noUpdate3d: 'No update 3d+',
    hello: 'Hello',
    updatedJustNow: 'Updated just now',
    pendingPackages: 'Pending packages',
    activePartners: 'Active partners',
    withPendingPackages: 'With pending packages',
    destinations: 'Destinations',
    destinationCountries: 'Destination countries',
    recommendation: 'Recommendation',
    newShipment: 'New Shipment',
    viewAnalytics: 'View Analytics',
    topDestinations: 'Top Destinations',
    viewAll: 'View all',
    noRecentActivity: 'No recent activity',

    // AnalysisDashboard
    periodAnalysis: 'Period analysis',
    periodAnalysisDesc: 'Cumulative revenue and charges evolution over a given period',
    routeProfitability: 'Route profitability',
    routeProfitabilityDesc: 'Profit and margin per shipping route',
    debtAging: 'Debt aging',
    debtAgingDesc: 'Unpaid invoices classified by age',
    paymentMethodAnalysis: 'Payment methods',
    paymentMethodAnalysisDesc: 'Breakdown of payment methods used',
    chargeBreakdown: 'Charges breakdown',
    chargeBreakdownDesc: 'Distribution of different charge types',

    // PlatformMonitoringPage
    sevenDays: '7 days',
    thirtyDays: '30 days',
    statsLoadError: 'Error loading statistics',
    logins: 'Logins',
    pageViews: 'Page views',
    uniqueUsers: 'Unique users',
    sessions: 'Sessions',
    activeUsersLabel: 'active users',
    noLoginsInPeriod: 'No logins in this period',
    noPageViewsInPeriod: 'No page views in this period',
    mostVisitedPages: 'Most visited pages',
    views: 'Views',
    devices: 'Devices',
    countries: 'Countries',
    unknown: 'Unknown',
    totalSessions: 'Total sessions',
    averageDuration: 'Average duration',
    pagesPerSession: 'Pages / session',
    pageDetails: 'Page details',
    uniqueVisitors: 'Unique visitors',

    // PlatformAdminPage
    platformAdmin: 'Platform Admin',
    platformAdminDesc: 'Centralized management of all companies',
    companies: 'Companies',
    subscriptions: 'Subscriptions',
    incidents: 'Incidents',
    activeUsers: 'Active Users',
    packagesThisMonth: 'Packages this month',
    openIncidents: 'open incidents',
    totalShipmentsOnPlatform: 'Total shipments on the platform',
    allRegisteredPackages: 'All registered packages',
    allCompanies: 'All companies',
    code: 'Code',
    contact: 'Contact',
    actions: 'Actions',
    suspend: 'Suspend',
    activate: 'Activate',
    noCompanies: 'No companies',
    searchNameOrEmail: 'Search name or email...',
    allRoles: 'All roles',
    results: 'results',
    totalSubscriptions: 'Total subscriptions',
    plan: 'Plan',
    period: 'Period',
    noSubscriptions: 'No subscriptions',
    acknowledged: 'Acknowledged',
    resolved: 'Resolved',
    closed: 'Closed',
    allCategories: 'All categories',
    category: 'Category',
    reportedBy: 'Reported by',
    date: 'Date',
    resolve: 'Resolve',
    noIncidents: 'No incidents',
    confirmSuspendCompany: 'Suspend company?',
    confirmActivateCompany: 'Reactivate company?',
    confirmDeleteCompany: 'Delete company?',
    confirmSuspendDesc: 'All users of "{name}" will be deactivated.',
    confirmActivateDesc: 'Users of "{name}" will be reactivated.',
    confirmDeleteDesc: '"{name}" will be deleted (soft-delete). This action is irreversible.',
    approve: 'Approve',
    confirmApproveCompany: 'Approve company?',
    confirmApproveDesc: 'Company "{name}" will be activated and its users will be able to sign in.',
    companyApproved: 'Company approved',
    errorApproval: 'Approval error',
    editSubscription: 'Edit subscription',
    resolveIncident: 'Resolve incident',
    resolutionNote: 'Resolution note',
    describeResolution: 'Describe the resolution...',
    errorLoadingAnalytics: 'Error loading analytics',
    errorLoadingCompanies: 'Error loading companies',
    errorLoadingUsers: 'Error loading users',
    errorLoadingSubscriptions: 'Error loading subscriptions',
    errorLoadingIncidents: 'Error loading incidents',
    companySuspended: 'Company suspended',
    errorSuspension: 'Suspension error',
    companyReactivated: 'Company reactivated',
    errorActivation: 'Activation error',
    companyDeleted: 'Company deleted',
    errorDeletion: 'Deletion error',
    subscriptionUpdated: 'Subscription updated',
    incidentResolved: 'Incident resolved',
    errorResolution: 'Resolution error',

    // AuditLogPage
    entityUser: 'User',
    entityPackage: 'Package',
    entityShipment: 'Shipment',
    entityCompany: 'Company',
    accessDenied: 'Access denied',
    adminOnlyPage: 'This page is restricted to administrators.',
    auditLogsDesc: 'History of all actions performed in the system',
    entityType: 'Entity type',
    entries: 'entries',
    entry: 'entry',
    noLogs: 'No logs',
    noLogsForFilters: 'No actions recorded for the selected filters',
    user: 'User',
    action: 'Action',
    entity: 'Entity',

    // TeamOrgChartSections
    headquarters: 'Headquarters',
    delivery: 'Delivery',
    headquartersAndDelivery: 'Headquarters & Delivery',
    errorFetchingMembers: 'Error fetching members',
    errorCreatingUser: 'Error creating user',
    selectCountryAndRole: 'Please select a country and a role',
    errorAssigningCountry: 'Error assigning country',
    reactivation: 'Reactivation',
    suspendedByAdmin: 'Suspended by administrator',
    errorStatusChange: 'Error changing status',
    noName: 'No name',
    orgChartBySection: 'Org Chart by Section',
    members: 'members',
    member: 'member',
    inYourTeam: 'in your team',
    addMember: 'Add a member',
    shippingCountriesHQ: 'Shipping Countries (HQ)',
    allShippingCountries: 'All shipping countries',
    destinationCountriesDelivery: 'Destination Countries (Delivery)',
    allDestinationCountries: 'All destination countries',
    membersFound: 'members found',
    memberFound: 'member found',
    generalManagement: 'General Management',
    countryAdministration: 'Country Administration',
    collectors: 'Collectors',
    deliveryPartners: 'Delivery Partners',
    memberDetails: 'Member details',
    detailedInfoAbout: 'Detailed information about',
    accountSuspended: 'Account suspended',
    accountActive: 'Account active',
    viewActivity: 'View activity',
    countryAssignment: 'Country Assignment',
    current: 'Current',
    headquartersShipping: 'Headquarters (Shipping)',
    deliveryCountries: 'Delivery Countries',
    selectType: 'Select a type',
    assigning: 'Assigning...',
    assignToCountry: 'Assign to country',
    processing: 'Processing...',
    reactivateAccount: 'Reactivate this account',
    suspendAccount: 'Suspend this account',
    addTeamMember: 'Add a Team Member',
    fillInfoToCreateMember: 'Fill in the information to create a new member.',
    minCharsPassword: 'Min. 8 characters',
    collectionPartner: 'Collection Partner',
    deliveryPartner: 'Delivery Partner',
    assignToShippingCountry: 'Assign to Shipping Country (HQ)',
    assignToDeliveryCountry: 'Assign to Destination Country (Delivery)',
    createMember: 'Create member',
    teamActiveMembers: 'Active members',
    teamSuspendedMembers: 'Suspended',
    teamAdmins: 'Administrators',
    teamPartners: 'Partners',
    searchMembers: 'Name, email, role...',
    filterAll: 'All',
    filterAdmins: 'Admin',
    filterCollectors: 'Collectors',
    filterDelivery: 'Delivery',
    filterClients: 'Clients',
    noMembersInFilter: 'No members found for this filter',
    tabUsers: 'Users',
    tabTeam: 'Team',
    tabRoles: 'Roles & Permissions',
    columnUser: 'User',
    columnRole: 'Role',
    columnScope: 'Scope',
    columnStatus: 'Status',
    statusActive: 'Active',
    statusSuspended: 'Suspended',
    noAssignment: 'Unassigned',
    rolesIntro: 'Available roles in your organization',
    roleSuperAdminDesc: 'Full access to all features and settings',
    roleCompanyAdminDesc: 'Company management, users and settings',
    roleCountryAdminDesc: 'Administration of a specific country (shipping or delivery)',
    rolePartnerDesc: 'Package collection in a departure country',
    roleLocalPartnerDesc: 'Package delivery in a destination country',
    roleClientDesc: 'Client who ships packages via the platform',
    permissionsCount: 'permissions',
    membersWithRole: 'members',
    tabClients: 'Clients',
    clientsSubtitle: 'Shippers & receivers database',
    permFull: 'Full',
    permEdit: 'Edit',
    permRead: 'Read',
    permScope: 'Scope',
    permSelf: 'Self',
    permNone: '—',
    permModule: 'Module',
    modShipments: 'Shipments',
    modPackages: 'Packages',
    modFinance: 'Finance',
    modUsers: 'Users',
    modPartners: 'Partners',
    modSettings: 'Settings',
    modTracking: 'Tracking',

    // UsersManagement
    usersManagement: 'Users Management',
    newUser: 'New User',
    userCreatedSuccess: 'User created successfully!',
    select: 'Select',
    errorDeletingUser: 'Error deleting user',
    errorEditingUser: 'Error editing user',

    // FlightAPITester
    enterFlightNumber: 'Please enter a flight number',
    flightApiUnavailable: 'Flight API service unavailable',
    errorSearching: 'Error during search',
    flightApiConnectionError: 'Flight API connection error',
    flight: 'Flight',
    generalInfo: 'General information',
    airline: 'Airline',
    notSpecified: 'Not specified',
    schedules: 'Schedules',
    scheduledDeparture: 'Scheduled departure',
    actualDeparture: 'Actual departure',
    scheduledArrival: 'Scheduled arrival',
    estimatedArrival: 'Estimated arrival',
    actualArrival: 'Actual arrival',
    airportInfo: 'Airport information',

    // Pagination
    showingResults: 'Showing {start} to {end} of {total} results',
    rowsPerPage: 'Rows per page:',

    // RealTimeNotifications
    newPlural: 'new',
    newSingular: 'new',
    markAllAsRead: 'Mark all as read',
    deleteRead: 'Delete read',

    // CompanyInfoDynamic
    errorFetching: 'Error fetching data',
    errorSaving: 'Error saving data',
    noSettingsFound: 'No settings found',
    freightForwarder: 'Freight Forwarder',
    carrier: 'Carrier',
    logisticsProvider: 'Logistics Provider',
    companyInfoLabel: 'Company Information',
    companyInfoDesc: 'Complete view and configuration of your company',
    settingsSavedSuccess: 'Settings saved successfully!',
    generalInformation: 'General Information',
    companyNameAndType: 'Company name and type',
    headquartersConfiguredPlural: 'headquarters configured',
    headquartersConfiguredSingular: 'headquarter configured',
    noHeadquartersConfigured: 'No headquarters configured',
    addHeadquarter: 'Add a headquarter',
    selectCountryHQ: 'Select a country (HQ)',
    headquarterAddress: 'Headquarter address',
    countriesConfiguredPlural: 'countries configured',
    countriesConfiguredSingular: 'country configured',
    noDeliveryCountriesConfigured: 'No delivery countries configured',
    addCountry: 'Add a country',
    pickupAddress: 'Pickup address',
    addAdditionalCountry: 'Add an additional country',
    routesAndTransit: 'Routes & Transit',
    transitDurationsAndRates: 'Transit durations and rates by route',
    transitDays: 'Transit (days)',
    transitDurationsByRoute: 'Transit durations by route',
    noTransitConfig: 'No transit configuration.',
    routePricingNote: 'Route pricing is configured in Finance > Pricing.',

    // BroadcastPage
    broadcastDesc: 'Send group messages to your clients',
    newMessage: 'New message',
    history: 'History',
    composeMessage: 'Compose a message',
    subject: 'Subject',
    messageSubjectPlaceholder: 'Message subject...',
    message: 'Message',
    messageContentPlaceholder: 'Message content...',
    sendingChannels: 'Sending channels',
    recipients: 'Recipients',
    byCountry: 'By country',
    clients: 'Clients',
    byShipmentFilter: 'By shipment',
    selectShipment: 'Select a shipment',
    recipientsPreview: 'Recipients preview',
    confirmSending: 'Confirm sending',
    channels: 'Channels',
    target: 'Target',
    allContacts: 'All contacts',
    irreversibleAction: 'This action is irreversible. Messages will be sent immediately.',
    errorPreview: 'Error during preview',
    broadcastLaunched: 'Broadcast launched! {count} recipients.',
    errorSending: 'Error sending',
    inProgress: 'In progress',
    sent: 'Sent',
    partial: 'Partial',
    failed: 'Failed',
    noBroadcastsSent: 'No broadcasts sent.',
    loadingRecipients: 'Loading recipients...',
    sendingInProgress: 'Sending in progress...',
    noRecipientsRegistered: 'No recipients registered',

    // Pricing ContactModal
    requestSent: 'Request sent!',
    teamWillContact: 'Our team will contact you within 24h to schedule your appointment.',
    bookAppointment: 'Book an appointment',
    enterprisePlanContact: 'Enterprise Plan — our team will contact you within 24h',
    professionalEmail: 'Professional email *',
    tellUsYourNeeds: 'Tell us about your needs (optional)',
    sendMyRequest: 'Send my request',

    // Relay Points / Delivery Mode
    relayPoints: 'Relay Points',
    relayPoint: 'Relay Point',
    relayPointName: 'Relay point name',
    relayPointAddress: 'Address',
    relayPointCity: 'City',
    relayPointPhone: 'Phone',
    relayPointOpeningHours: 'Opening hours',
    addRelayPoint: 'Add a relay point',
    deleteRelayPoint: 'Delete this relay point',
    selectRelayPoint: 'Select a relay point',
    relayPointPickup: 'Relay point pickup',
    openingHours: 'Opening hours',
    deliveryMode: 'Delivery mode',
    assignDeliveryMode: 'Assign delivery mode',
    homeDelivery: 'Home delivery',
    homeDeliveryDesc: 'The package will be delivered directly to the recipient',
    relayPointDesc: 'The recipient will pick up the package at the relay point',
    deliveryModeAssigned: 'Delivery mode assigned successfully',
    errorAssigningDeliveryMode: 'Error assigning delivery mode',
    noRelayPointsConfigured: 'No relay points configured',
    relayPointInfo: 'Relay point information',
    depositRelayPoint: 'Deposit at relay point',
    depositRelayPointDesc: 'Deposit the package at a relay point for recipient pickup',
    confirmDeposit: 'Confirm deposit',
    depositSuccess: 'Package deposited at relay point successfully',
    errorDeposit: 'Error depositing at relay point',
    atRelayPoint: 'At relay point',
    depositNotes: 'Deposit notes',
    deliveryHistory: 'Delivery history',
    noDeliveryHistory: 'No deliveries yet',
    refresh: 'Refresh',
    confirm: 'Confirm',

    // SEO
    seoLandingTitle: 'International freight management solution',
    seoLandingDesc: 'International freight management platform. Real-time tracking, shipment management, automatic notifications.',
    seoTrackTitle: 'Track My Package | FretManager',
    seoTrackDesc: 'Track your package in real time. Enter your tracking code to check your shipment status.',
    seoContactTitle: 'Contact | FretManager',
    seoContactDesc: 'Contact the FretManager team. Request a demo or ask questions about our freight management platform.',
    seoHelpTitle: 'Help Center | FretManager',
    seoHelpDesc: 'Find answers to your questions about FretManager. User guides, FAQ and technical support.',
    seoPrivacyTitle: 'Privacy Policy | FretManager',
    seoPrivacyDesc: 'Learn how FretManager protects your personal data and respects your privacy.',
    seoTermsTitle: 'Terms of Service | FretManager',
    seoTermsDesc: 'Review the terms and conditions of use for the FretManager platform.',
    seoLoginTitle: 'Login | FretManager',
    seoLoginDesc: 'Log in to your FretManager account to manage your shipments.',
    seoRegisterTitle: 'Sign Up | FretManager',
    seoRegisterDesc: 'Create your FretManager account and start managing your international shipments.',
    seoDashboardTitle: 'Dashboard | FretManager',
    seoDashboardDesc: 'FretManager dashboard — manage your shipments and packages.',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Charger la langue sauvegardée ou utiliser français par défaut
    return localStorage.getItem('language') || 'fr';
  });

  useEffect(() => {
    // Sauvegarder la langue sélectionnée
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const changeLanguage = (newLanguage) => {
    if (translations[newLanguage]) {
      setLanguage(newLanguage);
    }
  };

  const value = {
    language,
    changeLanguage,
    t,
    availableLanguages: [
      { code: 'fr', name: 'Français', flag: '🇫🇷' },
      { code: 'en', name: 'English', flag: '🇬🇧' }
    ]
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;